import gql from 'graphql-tag'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  ApofinderConfigAdsDynamicZoneInput: { input: any; output: any }
  ApofinderLandingPageAdsDynamicZoneInput: { input: any; output: any }
  ClickapoPharmacyTipsDynamicZoneInput: { input: any; output: any }
  DateTime: { input: any; output: any }
  I18NLocaleCode: { input: any; output: any }
  JSON: { input: any; output: any }
  Long: { input: any; output: any }
  Upload: { input: any; output: any }
}

export type ApofinderConfig = {
  __typename?: 'ApofinderConfig'
  ads?: Maybe<Array<Maybe<ApofinderConfigAdsDynamicZone>>>
  cnf: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  findPharmacyChoice?: Maybe<ComponentApofinderFindPharmacyChoice>
  infoBlock?: Maybe<ComponentApofinderInfoBlock>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<ApofinderConfigRelationResponseCollection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  queryParameters?: Maybe<Array<Maybe<ComponentApofinderQureyParameter>>>
  subtitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ApofinderConfigLocalizationsArgs = {
  filters?: InputMaybe<ApofinderConfigFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ApofinderConfigQueryParametersArgs = {
  filters?: InputMaybe<ComponentApofinderQureyParameterFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ApofinderConfigAdsDynamicZone = ComponentApofinderGoogleAd | ComponentApofinderImageAd | Error

export type ApofinderConfigEntity = {
  __typename?: 'ApofinderConfigEntity'
  attributes?: Maybe<ApofinderConfig>
  id?: Maybe<Scalars['ID']['output']>
}

export type ApofinderConfigEntityResponse = {
  __typename?: 'ApofinderConfigEntityResponse'
  data?: Maybe<ApofinderConfigEntity>
}

export type ApofinderConfigEntityResponseCollection = {
  __typename?: 'ApofinderConfigEntityResponseCollection'
  data: Array<ApofinderConfigEntity>
  meta: ResponseCollectionMeta
}

export type ApofinderConfigFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ApofinderConfigFiltersInput>>>
  cnf?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  findPharmacyChoice?: InputMaybe<ComponentApofinderFindPharmacyChoiceFiltersInput>
  id?: InputMaybe<IdFilterInput>
  infoBlock?: InputMaybe<ComponentApofinderInfoBlockFiltersInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<ApofinderConfigFiltersInput>
  not?: InputMaybe<ApofinderConfigFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ApofinderConfigFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  queryParameters?: InputMaybe<ComponentApofinderQureyParameterFiltersInput>
  subtitle?: InputMaybe<StringFilterInput>
  title?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type ApofinderConfigInput = {
  ads?: InputMaybe<Array<Scalars['ApofinderConfigAdsDynamicZoneInput']['input']>>
  cnf?: InputMaybe<Scalars['String']['input']>
  findPharmacyChoice?: InputMaybe<ComponentApofinderFindPharmacyChoiceInput>
  infoBlock?: InputMaybe<ComponentApofinderInfoBlockInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  queryParameters?: InputMaybe<Array<InputMaybe<ComponentApofinderQureyParameterInput>>>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ApofinderConfigRelationResponseCollection = {
  __typename?: 'ApofinderConfigRelationResponseCollection'
  data: Array<ApofinderConfigEntity>
}

export type ApofinderLandingPage = {
  __typename?: 'ApofinderLandingPage'
  ads?: Maybe<Array<Maybe<ApofinderLandingPageAdsDynamicZone>>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  findPharmacyChoice?: Maybe<ComponentApofinderFindPharmacyChoice>
  infoBlock?: Maybe<ComponentApofinderInfoBlock>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<ApofinderLandingPageRelationResponseCollection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  queryParameters?: Maybe<Array<Maybe<ComponentApofinderQureyParameter>>>
  subtitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ApofinderLandingPageLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>
}

export type ApofinderLandingPageQueryParametersArgs = {
  filters?: InputMaybe<ComponentApofinderQureyParameterFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ApofinderLandingPageAdsDynamicZone = ComponentApofinderGoogleAd | ComponentApofinderImageAd | Error

export type ApofinderLandingPageEntity = {
  __typename?: 'ApofinderLandingPageEntity'
  attributes?: Maybe<ApofinderLandingPage>
  id?: Maybe<Scalars['ID']['output']>
}

export type ApofinderLandingPageEntityResponse = {
  __typename?: 'ApofinderLandingPageEntityResponse'
  data?: Maybe<ApofinderLandingPageEntity>
}

export type ApofinderLandingPageInput = {
  ads?: InputMaybe<Array<Scalars['ApofinderLandingPageAdsDynamicZoneInput']['input']>>
  findPharmacyChoice?: InputMaybe<ComponentApofinderFindPharmacyChoiceInput>
  infoBlock?: InputMaybe<ComponentApofinderInfoBlockInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  queryParameters?: InputMaybe<Array<InputMaybe<ComponentApofinderQureyParameterInput>>>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ApofinderLandingPageRelationResponseCollection = {
  __typename?: 'ApofinderLandingPageRelationResponseCollection'
  data: Array<ApofinderLandingPageEntity>
}

export type AppSdk = {
  __typename?: 'AppSdk'
  cardLinkConfiguration?: Maybe<ComponentSdkCardLinkConfiguration>
  clients?: Maybe<Array<Maybe<ComponentSdkClient>>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  imprint?: Maybe<Array<Maybe<ComponentSdkLegalDocuments>>>
  infrastructure?: Maybe<ComponentSdkInfrastructure>
  onboardingPages?: Maybe<Array<Maybe<ComponentSdkOnboardingPage>>>
  privacyPolicy?: Maybe<Array<Maybe<ComponentSdkLegalDocuments>>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  termsOfService?: Maybe<Array<Maybe<ComponentSdkLegalDocuments>>>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type AppSdkClientsArgs = {
  filters?: InputMaybe<ComponentSdkClientFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type AppSdkImprintArgs = {
  filters?: InputMaybe<ComponentSdkLegalDocumentsFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type AppSdkOnboardingPagesArgs = {
  filters?: InputMaybe<ComponentSdkOnboardingPageFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type AppSdkPrivacyPolicyArgs = {
  filters?: InputMaybe<ComponentSdkLegalDocumentsFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type AppSdkTermsOfServiceArgs = {
  filters?: InputMaybe<ComponentSdkLegalDocumentsFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type AppSdkEntity = {
  __typename?: 'AppSdkEntity'
  attributes?: Maybe<AppSdk>
  id?: Maybe<Scalars['ID']['output']>
}

export type AppSdkEntityResponse = {
  __typename?: 'AppSdkEntityResponse'
  data?: Maybe<AppSdkEntity>
}

export type AppSdkInput = {
  cardLinkConfiguration?: InputMaybe<ComponentSdkCardLinkConfigurationInput>
  clients?: InputMaybe<Array<InputMaybe<ComponentSdkClientInput>>>
  imprint?: InputMaybe<Array<InputMaybe<ComponentSdkLegalDocumentsInput>>>
  infrastructure?: InputMaybe<ComponentSdkInfrastructureInput>
  onboardingPages?: InputMaybe<Array<InputMaybe<ComponentSdkOnboardingPageInput>>>
  privacyPolicy?: InputMaybe<Array<InputMaybe<ComponentSdkLegalDocumentsInput>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  termsOfService?: InputMaybe<Array<InputMaybe<ComponentSdkLegalDocumentsInput>>>
}

export type BepServiceHoursHelp = {
  __typename?: 'BepServiceHoursHelp'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  helpText?: Maybe<Scalars['String']['output']>
  helpTitle?: Maybe<Scalars['String']['output']>
  pharmacyName: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type BepServiceHoursHelpEntity = {
  __typename?: 'BepServiceHoursHelpEntity'
  attributes?: Maybe<BepServiceHoursHelp>
  id?: Maybe<Scalars['ID']['output']>
}

export type BepServiceHoursHelpEntityResponse = {
  __typename?: 'BepServiceHoursHelpEntityResponse'
  data?: Maybe<BepServiceHoursHelpEntity>
}

export type BepServiceHoursHelpEntityResponseCollection = {
  __typename?: 'BepServiceHoursHelpEntityResponseCollection'
  data: Array<BepServiceHoursHelpEntity>
  meta: ResponseCollectionMeta
}

export type BepServiceHoursHelpFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BepServiceHoursHelpFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  helpText?: InputMaybe<StringFilterInput>
  helpTitle?: InputMaybe<StringFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<BepServiceHoursHelpFiltersInput>
  or?: InputMaybe<Array<InputMaybe<BepServiceHoursHelpFiltersInput>>>
  pharmacyName?: InputMaybe<StringFilterInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type BepServiceHoursHelpInput = {
  helpText?: InputMaybe<Scalars['String']['input']>
  helpTitle?: InputMaybe<Scalars['String']['input']>
  pharmacyName?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  contains?: InputMaybe<Scalars['Boolean']['input']>
  containsi?: InputMaybe<Scalars['Boolean']['input']>
  endsWith?: InputMaybe<Scalars['Boolean']['input']>
  eq?: InputMaybe<Scalars['Boolean']['input']>
  eqi?: InputMaybe<Scalars['Boolean']['input']>
  gt?: InputMaybe<Scalars['Boolean']['input']>
  gte?: InputMaybe<Scalars['Boolean']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  lt?: InputMaybe<Scalars['Boolean']['input']>
  lte?: InputMaybe<Scalars['Boolean']['input']>
  ne?: InputMaybe<Scalars['Boolean']['input']>
  nei?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<BooleanFilterInput>
  notContains?: InputMaybe<Scalars['Boolean']['input']>
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
  startsWith?: InputMaybe<Scalars['Boolean']['input']>
}

export type Clickapo = {
  __typename?: 'Clickapo'
  bottomSheets?: Maybe<Array<Maybe<ComponentClickapoPopup>>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  faq?: Maybe<ComponentClickapoFaq>
  landingScreens?: Maybe<Array<Maybe<ComponentClickapoLandingScreen>>>
  limbachCategories?: Maybe<ComponentClickapoLimbachCategories>
  limbachFaq?: Maybe<ComponentClickapoLimbachFaq>
  limbachFaqAHD?: Maybe<ComponentClickapoLimbachFaqAhd>
  onboarding?: Maybe<Array<Maybe<ComponentClickapoOnboardingSlider>>>
  pharmacyTips?: Maybe<Array<Maybe<ClickapoPharmacyTipsDynamicZone>>>
  popularTopic?: Maybe<Array<Maybe<ComponentClickapoPopularTopics>>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  scanners?: Maybe<Array<Maybe<ComponentClickapoScanner>>>
  seasonalTopics?: Maybe<ComponentClickapoSeasonalTopics>
  startScreen?: Maybe<ComponentClickapoHomepageSlider>
  supplyPackageFaq?: Maybe<ComponentClickapoSupplyPackageFaq>
  tips?: Maybe<ComponentClickapoTips>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ClickapoBottomSheetsArgs = {
  filters?: InputMaybe<ComponentClickapoPopupFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ClickapoLandingScreensArgs = {
  filters?: InputMaybe<ComponentClickapoLandingScreenFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ClickapoOnboardingArgs = {
  filters?: InputMaybe<ComponentClickapoOnboardingSliderFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ClickapoPopularTopicArgs = {
  filters?: InputMaybe<ComponentClickapoPopularTopicsFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ClickapoScannersArgs = {
  filters?: InputMaybe<ComponentClickapoScannerFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ClickapoEntity = {
  __typename?: 'ClickapoEntity'
  attributes?: Maybe<Clickapo>
  id?: Maybe<Scalars['ID']['output']>
}

export type ClickapoEntityResponse = {
  __typename?: 'ClickapoEntityResponse'
  data?: Maybe<ClickapoEntity>
}

export type ClickapoInput = {
  bottomSheets?: InputMaybe<Array<InputMaybe<ComponentClickapoPopupInput>>>
  faq?: InputMaybe<ComponentClickapoFaqInput>
  landingScreens?: InputMaybe<Array<InputMaybe<ComponentClickapoLandingScreenInput>>>
  limbachCategories?: InputMaybe<ComponentClickapoLimbachCategoriesInput>
  limbachFaq?: InputMaybe<ComponentClickapoLimbachFaqInput>
  limbachFaqAHD?: InputMaybe<ComponentClickapoLimbachFaqAhdInput>
  onboarding?: InputMaybe<Array<InputMaybe<ComponentClickapoOnboardingSliderInput>>>
  pharmacyTips?: InputMaybe<Array<Scalars['ClickapoPharmacyTipsDynamicZoneInput']['input']>>
  popularTopic?: InputMaybe<Array<InputMaybe<ComponentClickapoPopularTopicsInput>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  scanners?: InputMaybe<Array<InputMaybe<ComponentClickapoScannerInput>>>
  seasonalTopics?: InputMaybe<ComponentClickapoSeasonalTopicsInput>
  startScreen?: InputMaybe<ComponentClickapoHomepageSliderInput>
  supplyPackageFaq?: InputMaybe<ComponentClickapoSupplyPackageFaqInput>
  tips?: InputMaybe<ComponentClickapoTipsInput>
}

export type ClickapoPharmacyTipsDynamicZone = ComponentClickapoTipsAnchorList | ComponentClickapoTipsBannerBlock | ComponentClickapoTipsIntro | ComponentClickapoTipsListBlock | ComponentClickapoTipsProductsBlock | Error

export type CommercialBanner = {
  __typename?: 'CommercialBanner'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  desktopImage: UploadFileEntityResponse
  link: Scalars['String']['output']
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<CommercialBannerRelationResponseCollection>
  mobileImage: UploadFileEntityResponse
  name: Scalars['String']['output']
  openNewWindow?: Maybe<Scalars['Boolean']['output']>
  pcase?: Maybe<Array<Maybe<ComponentSharedPcase>>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CommercialBannerLocalizationsArgs = {
  filters?: InputMaybe<CommercialBannerFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CommercialBannerPcaseArgs = {
  filters?: InputMaybe<ComponentSharedPcaseFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type CommercialBannerEntity = {
  __typename?: 'CommercialBannerEntity'
  attributes?: Maybe<CommercialBanner>
  id?: Maybe<Scalars['ID']['output']>
}

export type CommercialBannerEntityResponse = {
  __typename?: 'CommercialBannerEntityResponse'
  data?: Maybe<CommercialBannerEntity>
}

export type CommercialBannerEntityResponseCollection = {
  __typename?: 'CommercialBannerEntityResponseCollection'
  data: Array<CommercialBannerEntity>
  meta: ResponseCollectionMeta
}

export type CommercialBannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CommercialBannerFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  link?: InputMaybe<StringFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<CommercialBannerFiltersInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<CommercialBannerFiltersInput>
  openNewWindow?: InputMaybe<BooleanFilterInput>
  or?: InputMaybe<Array<InputMaybe<CommercialBannerFiltersInput>>>
  pcase?: InputMaybe<ComponentSharedPcaseFiltersInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type CommercialBannerInput = {
  desktopImage?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  mobileImage?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  openNewWindow?: InputMaybe<Scalars['Boolean']['input']>
  pcase?: InputMaybe<Array<InputMaybe<ComponentSharedPcaseInput>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type CommercialBannerRelationResponseCollection = {
  __typename?: 'CommercialBannerRelationResponseCollection'
  data: Array<CommercialBannerEntity>
}

export type ComponentApofinderAdvertisements = {
  __typename?: 'ComponentApofinderAdvertisements'
  googleAd?: Maybe<ComponentApofinderGoogleAd>
  id: Scalars['ID']['output']
  imageAd?: Maybe<ComponentApofinderImageAd>
  type?: Maybe<Enum_Componentapofinderadvertisements_Type>
}

export type ComponentApofinderButtons = {
  __typename?: 'ComponentApofinderButtons'
  displayScanButton?: Maybe<Scalars['Boolean']['output']>
  findPharmacyButtonLabel?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  scanPharmacyButtonLabel?: Maybe<Scalars['String']['output']>
}

export type ComponentApofinderButtonsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentApofinderButtonsFiltersInput>>>
  displayScanButton?: InputMaybe<BooleanFilterInput>
  findPharmacyButtonLabel?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentApofinderButtonsFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentApofinderButtonsFiltersInput>>>
  scanPharmacyButtonLabel?: InputMaybe<StringFilterInput>
}

export type ComponentApofinderButtonsInput = {
  displayScanButton?: InputMaybe<Scalars['Boolean']['input']>
  findPharmacyButtonLabel?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  scanPharmacyButtonLabel?: InputMaybe<Scalars['String']['input']>
}

export type ComponentApofinderFindPharmacyChoice = {
  __typename?: 'ComponentApofinderFindPharmacyChoice'
  buttons?: Maybe<ComponentApofinderButtons>
  display?: Maybe<Enum_Componentapofinderfindpharmacychoice_Display>
  id: Scalars['ID']['output']
  inputField?: Maybe<ComponentApofinderInputField>
}

export type ComponentApofinderFindPharmacyChoiceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentApofinderFindPharmacyChoiceFiltersInput>>>
  buttons?: InputMaybe<ComponentApofinderButtonsFiltersInput>
  display?: InputMaybe<StringFilterInput>
  inputField?: InputMaybe<ComponentApofinderInputFieldFiltersInput>
  not?: InputMaybe<ComponentApofinderFindPharmacyChoiceFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentApofinderFindPharmacyChoiceFiltersInput>>>
}

export type ComponentApofinderFindPharmacyChoiceInput = {
  buttons?: InputMaybe<ComponentApofinderButtonsInput>
  display?: InputMaybe<Enum_Componentapofinderfindpharmacychoice_Display>
  id?: InputMaybe<Scalars['ID']['input']>
  inputField?: InputMaybe<ComponentApofinderInputFieldInput>
}

export type ComponentApofinderGoogleAd = {
  __typename?: 'ComponentApofinderGoogleAd'
  bodyScript?: Maybe<Scalars['String']['output']>
  headScript?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type ComponentApofinderImageAd = {
  __typename?: 'ComponentApofinderImageAd'
  id: Scalars['ID']['output']
  imageDesktop?: Maybe<UploadFileEntityResponse>
  imageMobile?: Maybe<UploadFileEntityResponse>
  link?: Maybe<Scalars['String']['output']>
  newWindow?: Maybe<Scalars['Boolean']['output']>
}

export type ComponentApofinderInfoBlock = {
  __typename?: 'ComponentApofinderInfoBlock'
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileEntityResponse>
  imagePosition?: Maybe<Enum_Componentapofinderinfoblock_Imageposition>
  pzn?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type ComponentApofinderInfoBlockFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentApofinderInfoBlockFiltersInput>>>
  imagePosition?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentApofinderInfoBlockFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentApofinderInfoBlockFiltersInput>>>
  pzn?: InputMaybe<StringFilterInput>
  text?: InputMaybe<StringFilterInput>
}

export type ComponentApofinderInfoBlockInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  imagePosition?: InputMaybe<Enum_Componentapofinderinfoblock_Imageposition>
  pzn?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type ComponentApofinderInputField = {
  __typename?: 'ComponentApofinderInputField'
  id: Scalars['ID']['output']
  placeholder?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type ComponentApofinderInputFieldFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentApofinderInputFieldFiltersInput>>>
  not?: InputMaybe<ComponentApofinderInputFieldFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentApofinderInputFieldFiltersInput>>>
  placeholder?: InputMaybe<StringFilterInput>
  value?: InputMaybe<StringFilterInput>
}

export type ComponentApofinderInputFieldInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  placeholder?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type ComponentApofinderQureyParameter = {
  __typename?: 'ComponentApofinderQureyParameter'
  id: Scalars['ID']['output']
  param?: Maybe<Scalars['String']['output']>
}

export type ComponentApofinderQureyParameterFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentApofinderQureyParameterFiltersInput>>>
  not?: InputMaybe<ComponentApofinderQureyParameterFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentApofinderQureyParameterFiltersInput>>>
  param?: InputMaybe<StringFilterInput>
}

export type ComponentApofinderQureyParameterInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  param?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoBlueBanner = {
  __typename?: 'ComponentClickapoBlueBanner'
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileEntityResponse>
}

export type ComponentClickapoBlueBannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoBlueBannerFiltersInput>>>
  not?: InputMaybe<ComponentClickapoBlueBannerFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoBlueBannerFiltersInput>>>
}

export type ComponentClickapoBlueBannerInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
}

export type ComponentClickapoBottomSheet = {
  __typename?: 'ComponentClickapoBottomSheet'
  content?: Maybe<Array<Maybe<ComponentClickapoBottomSheetContent>>>
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoBottomSheetContentArgs = {
  filters?: InputMaybe<ComponentClickapoBottomSheetContentFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoBottomSheetContent = {
  __typename?: 'ComponentClickapoBottomSheetContent'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoBottomSheetContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoBottomSheetContentFiltersInput>>>
  description?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoBottomSheetContentFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoBottomSheetContentFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoFaq = {
  __typename?: 'ComponentClickapoFaq'
  categories?: Maybe<Array<Maybe<ComponentClickapoFaqCategory>>>
  content?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  subtitle?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoFaqCategoriesArgs = {
  filters?: InputMaybe<ComponentClickapoFaqCategoryFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoFaqCategory = {
  __typename?: 'ComponentClickapoFaqCategory'
  content?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  questions?: Maybe<Array<Maybe<ComponentClickapoFaqQuestion>>>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoFaqCategoryQuestionsArgs = {
  filters?: InputMaybe<ComponentClickapoFaqQuestionFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoFaqCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoFaqCategoryFiltersInput>>>
  content?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoFaqCategoryFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoFaqCategoryFiltersInput>>>
  questions?: InputMaybe<ComponentClickapoFaqQuestionFiltersInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoFaqCategoryInput = {
  content?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  questions?: InputMaybe<Array<InputMaybe<ComponentClickapoFaqQuestionInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoFaqInput = {
  categories?: InputMaybe<Array<InputMaybe<ComponentClickapoFaqCategoryInput>>>
  content?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoFaqQuestion = {
  __typename?: 'ComponentClickapoFaqQuestion'
  answer: Scalars['String']['output']
  id: Scalars['ID']['output']
  question: Scalars['String']['output']
}

export type ComponentClickapoFaqQuestionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoFaqQuestionFiltersInput>>>
  answer?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoFaqQuestionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoFaqQuestionFiltersInput>>>
  question?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoFaqQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  question?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoHomepageSlider = {
  __typename?: 'ComponentClickapoHomepageSlider'
  blueBanners?: Maybe<Array<Maybe<ComponentClickapoBlueBanner>>>
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  startScreenSliderItem?: Maybe<Array<Maybe<ComponentClickapoHomepageSliderItem>>>
}

export type ComponentClickapoHomepageSliderBlueBannersArgs = {
  filters?: InputMaybe<ComponentClickapoBlueBannerFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoHomepageSliderStartScreenSliderItemArgs = {
  filters?: InputMaybe<ComponentClickapoHomepageSliderItemFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoHomepageSliderInput = {
  blueBanners?: InputMaybe<Array<InputMaybe<ComponentClickapoBlueBannerInput>>>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  startScreenSliderItem?: InputMaybe<Array<InputMaybe<ComponentClickapoHomepageSliderItemInput>>>
}

export type ComponentClickapoHomepageSliderItem = {
  __typename?: 'ComponentClickapoHomepageSliderItem'
  enabled?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  image: UploadFileEntityResponse
  pcases?: Maybe<PcaseRelationResponseCollection>
  products?: Maybe<Scalars['JSON']['output']>
  providr?: Maybe<ProviderRelationResponseCollection>
  title: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoHomepageSliderItemPcasesArgs = {
  filters?: InputMaybe<PcaseFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoHomepageSliderItemProvidrArgs = {
  filters?: InputMaybe<ProviderFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoHomepageSliderItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoHomepageSliderItemFiltersInput>>>
  enabled?: InputMaybe<BooleanFilterInput>
  not?: InputMaybe<ComponentClickapoHomepageSliderItemFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoHomepageSliderItemFiltersInput>>>
  pcases?: InputMaybe<PcaseFiltersInput>
  products?: InputMaybe<JsonFilterInput>
  providr?: InputMaybe<ProviderFiltersInput>
  title?: InputMaybe<StringFilterInput>
  url?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoHomepageSliderItemInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  pcases?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  products?: InputMaybe<Scalars['JSON']['input']>
  providr?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  title?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoLandingScreen = {
  __typename?: 'ComponentClickapoLandingScreen'
  bulletPoint?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  hint?: Maybe<ComponentClickapoLandingScreenHint>
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileEntityResponse>
  imageNullable?: Maybe<UploadFileEntityResponse>
  sectionContent?: Maybe<Array<Maybe<ComponentClickapoSectionContent>>>
  sectionTitle?: Maybe<ComponentClickapoSection>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoLandingScreenSectionContentArgs = {
  filters?: InputMaybe<ComponentClickapoSectionContentFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoLandingScreenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoLandingScreenFiltersInput>>>
  bulletPoint?: InputMaybe<StringFilterInput>
  description?: InputMaybe<StringFilterInput>
  hint?: InputMaybe<ComponentClickapoLandingScreenHintFiltersInput>
  not?: InputMaybe<ComponentClickapoLandingScreenFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoLandingScreenFiltersInput>>>
  sectionContent?: InputMaybe<ComponentClickapoSectionContentFiltersInput>
  sectionTitle?: InputMaybe<ComponentClickapoSectionFiltersInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoLandingScreenHint = {
  __typename?: 'ComponentClickapoLandingScreenHint'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoLandingScreenHintFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoLandingScreenHintFiltersInput>>>
  description?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoLandingScreenHintFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoLandingScreenHintFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoLandingScreenHintInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoLandingScreenInput = {
  bulletPoint?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  hint?: InputMaybe<ComponentClickapoLandingScreenHintInput>
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  imageNullable?: InputMaybe<Scalars['ID']['input']>
  sectionContent?: InputMaybe<Array<InputMaybe<ComponentClickapoSectionContentInput>>>
  sectionTitle?: InputMaybe<ComponentClickapoSectionInput>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoLimbachCategories = {
  __typename?: 'ComponentClickapoLimbachCategories'
  id: Scalars['ID']['output']
  mainImage: UploadFileEntityResponse
  title: Scalars['String']['output']
  topics?: Maybe<Array<Maybe<ComponentClickapoLimbachCategoriesTopic>>>
}

export type ComponentClickapoLimbachCategoriesTopicsArgs = {
  filters?: InputMaybe<ComponentClickapoLimbachCategoriesTopicFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoLimbachCategoriesInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  mainImage?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  topics?: InputMaybe<Array<InputMaybe<ComponentClickapoLimbachCategoriesTopicInput>>>
}

export type ComponentClickapoLimbachCategoriesSubtopic = {
  __typename?: 'ComponentClickapoLimbachCategoriesSubtopic'
  description?: Maybe<Scalars['JSON']['output']>
  id: Scalars['ID']['output']
  pznList: Scalars['JSON']['output']
  title: Scalars['String']['output']
}

export type ComponentClickapoLimbachCategoriesSubtopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoLimbachCategoriesSubtopicFiltersInput>>>
  description?: InputMaybe<JsonFilterInput>
  not?: InputMaybe<ComponentClickapoLimbachCategoriesSubtopicFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoLimbachCategoriesSubtopicFiltersInput>>>
  pznList?: InputMaybe<JsonFilterInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoLimbachCategoriesSubtopicInput = {
  description?: InputMaybe<Scalars['JSON']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  pznList?: InputMaybe<Scalars['JSON']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoLimbachCategoriesTopic = {
  __typename?: 'ComponentClickapoLimbachCategoriesTopic'
  description: Scalars['JSON']['output']
  headerImage: UploadFileEntityResponse
  id: Scalars['ID']['output']
  pznList?: Maybe<Scalars['JSON']['output']>
  subtopics?: Maybe<Array<Maybe<ComponentClickapoLimbachCategoriesSubtopic>>>
  svgIcon?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type ComponentClickapoLimbachCategoriesTopicSubtopicsArgs = {
  filters?: InputMaybe<ComponentClickapoLimbachCategoriesSubtopicFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoLimbachCategoriesTopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoLimbachCategoriesTopicFiltersInput>>>
  description?: InputMaybe<JsonFilterInput>
  not?: InputMaybe<ComponentClickapoLimbachCategoriesTopicFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoLimbachCategoriesTopicFiltersInput>>>
  pznList?: InputMaybe<JsonFilterInput>
  subtopics?: InputMaybe<ComponentClickapoLimbachCategoriesSubtopicFiltersInput>
  svgIcon?: InputMaybe<StringFilterInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoLimbachCategoriesTopicInput = {
  description?: InputMaybe<Scalars['JSON']['input']>
  headerImage?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  pznList?: InputMaybe<Scalars['JSON']['input']>
  subtopics?: InputMaybe<Array<InputMaybe<ComponentClickapoLimbachCategoriesSubtopicInput>>>
  svgIcon?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoLimbachFaq = {
  __typename?: 'ComponentClickapoLimbachFaq'
  id: Scalars['ID']['output']
  questions?: Maybe<Array<Maybe<ComponentClickapoFaqQuestion>>>
  title: Scalars['String']['output']
}

export type ComponentClickapoLimbachFaqQuestionsArgs = {
  filters?: InputMaybe<ComponentClickapoFaqQuestionFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoLimbachFaqAhd = {
  __typename?: 'ComponentClickapoLimbachFaqAhd'
  id: Scalars['ID']['output']
  questions?: Maybe<Array<Maybe<ComponentClickapoFaqQuestion>>>
  title: Scalars['String']['output']
}

export type ComponentClickapoLimbachFaqAhdQuestionsArgs = {
  filters?: InputMaybe<ComponentClickapoFaqQuestionFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoLimbachFaqAhdInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  questions?: InputMaybe<Array<InputMaybe<ComponentClickapoFaqQuestionInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoLimbachFaqInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  questions?: InputMaybe<Array<InputMaybe<ComponentClickapoFaqQuestionInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoOnboardingSlider = {
  __typename?: 'ComponentClickapoOnboardingSlider'
  footer?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileEntityResponse>
  sections?: Maybe<Array<Maybe<ComponentClickapoOnboardingSliderContentItem>>>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoOnboardingSliderSectionsArgs = {
  filters?: InputMaybe<ComponentClickapoOnboardingSliderContentItemFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoOnboardingSliderContentItem = {
  __typename?: 'ComponentClickapoOnboardingSliderContentItem'
  content?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoOnboardingSliderContentItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoOnboardingSliderContentItemFiltersInput>>>
  content?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoOnboardingSliderContentItemFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoOnboardingSliderContentItemFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoOnboardingSliderContentItemInput = {
  content?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoOnboardingSliderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoOnboardingSliderFiltersInput>>>
  footer?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoOnboardingSliderFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoOnboardingSliderFiltersInput>>>
  sections?: InputMaybe<ComponentClickapoOnboardingSliderContentItemFiltersInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoOnboardingSliderInput = {
  footer?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  sections?: InputMaybe<Array<InputMaybe<ComponentClickapoOnboardingSliderContentItemInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoPopularTopics = {
  __typename?: 'ComponentClickapoPopularTopics'
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  image: UploadFileEntityResponse
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ComponentClickapoPopularTopicsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoPopularTopicsFiltersInput>>>
  enabled?: InputMaybe<BooleanFilterInput>
  not?: InputMaybe<ComponentClickapoPopularTopicsFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoPopularTopicsFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
  url?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoPopularTopicsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoPopup = {
  __typename?: 'ComponentClickapoPopup'
  id: Scalars['ID']['output']
  sections?: Maybe<Array<Maybe<ComponentClickapoPopupSection>>>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoPopupSectionsArgs = {
  filters?: InputMaybe<ComponentClickapoPopupSectionFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoPopupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoPopupFiltersInput>>>
  not?: InputMaybe<ComponentClickapoPopupFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoPopupFiltersInput>>>
  sections?: InputMaybe<ComponentClickapoPopupSectionFiltersInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoPopupInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  sections?: InputMaybe<Array<InputMaybe<ComponentClickapoPopupSectionInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoPopupSection = {
  __typename?: 'ComponentClickapoPopupSection'
  content?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoPopupSectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoPopupSectionFiltersInput>>>
  content?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoPopupSectionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoPopupSectionFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoPopupSectionInput = {
  content?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoScanner = {
  __typename?: 'ComponentClickapoScanner'
  description?: Maybe<Scalars['String']['output']>
  heading?: Maybe<Scalars['String']['output']>
  hint?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  scannerType: Scalars['String']['output']
  tips?: Maybe<ComponentClickapoScannerTipList>
  title: Scalars['String']['output']
}

export type ComponentClickapoScannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoScannerFiltersInput>>>
  description?: InputMaybe<StringFilterInput>
  heading?: InputMaybe<StringFilterInput>
  hint?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoScannerFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoScannerFiltersInput>>>
  scannerType?: InputMaybe<StringFilterInput>
  tips?: InputMaybe<ComponentClickapoScannerTipListFiltersInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoScannerInput = {
  description?: InputMaybe<Scalars['String']['input']>
  heading?: InputMaybe<Scalars['String']['input']>
  hint?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  scannerType?: InputMaybe<Scalars['String']['input']>
  tips?: InputMaybe<ComponentClickapoScannerTipListInput>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoScannerTip = {
  __typename?: 'ComponentClickapoScannerTip'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  title: Scalars['String']['output']
}

export type ComponentClickapoScannerTipFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoScannerTipFiltersInput>>>
  description?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoScannerTipFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoScannerTipFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoScannerTipInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoScannerTipList = {
  __typename?: 'ComponentClickapoScannerTipList'
  id: Scalars['ID']['output']
  tips?: Maybe<Array<Maybe<ComponentClickapoScannerTip>>>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoScannerTipListTipsArgs = {
  filters?: InputMaybe<ComponentClickapoScannerTipFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoScannerTipListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoScannerTipListFiltersInput>>>
  not?: InputMaybe<ComponentClickapoScannerTipListFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoScannerTipListFiltersInput>>>
  tips?: InputMaybe<ComponentClickapoScannerTipFiltersInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoScannerTipListInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  tips?: InputMaybe<Array<InputMaybe<ComponentClickapoScannerTipInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoSeasonTopic = {
  __typename?: 'ComponentClickapoSeasonTopic'
  adBanner?: Maybe<UploadFileEntityResponse>
  description: Scalars['JSON']['output']
  enabled: Scalars['Boolean']['output']
  headerImage: UploadFileEntityResponse
  iconImage: UploadFileEntityResponse
  id: Scalars['ID']['output']
  pznList: Scalars['JSON']['output']
  svgIcon?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type ComponentClickapoSeasonTopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoSeasonTopicFiltersInput>>>
  description?: InputMaybe<JsonFilterInput>
  enabled?: InputMaybe<BooleanFilterInput>
  not?: InputMaybe<ComponentClickapoSeasonTopicFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoSeasonTopicFiltersInput>>>
  pznList?: InputMaybe<JsonFilterInput>
  svgIcon?: InputMaybe<StringFilterInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoSeasonTopicInput = {
  adBanner?: InputMaybe<Scalars['ID']['input']>
  description?: InputMaybe<Scalars['JSON']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  headerImage?: InputMaybe<Scalars['ID']['input']>
  iconImage?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  pznList?: InputMaybe<Scalars['JSON']['input']>
  svgIcon?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoSeasonalTopics = {
  __typename?: 'ComponentClickapoSeasonalTopics'
  id: Scalars['ID']['output']
  mainImage: UploadFileEntityResponse
  title: Scalars['String']['output']
  topics: Array<Maybe<ComponentClickapoSeasonTopic>>
}

export type ComponentClickapoSeasonalTopicsTopicsArgs = {
  filters?: InputMaybe<ComponentClickapoSeasonTopicFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoSeasonalTopicsInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  mainImage?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  topics?: InputMaybe<Array<InputMaybe<ComponentClickapoSeasonTopicInput>>>
}

export type ComponentClickapoSection = {
  __typename?: 'ComponentClickapoSection'
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoSectionContent = {
  __typename?: 'ComponentClickapoSectionContent'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoSectionContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoSectionContentFiltersInput>>>
  description?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoSectionContentFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoSectionContentFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoSectionContentInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoSectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoSectionFiltersInput>>>
  not?: InputMaybe<ComponentClickapoSectionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoSectionFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoSupplyPackageFaq = {
  __typename?: 'ComponentClickapoSupplyPackageFaq'
  id: Scalars['ID']['output']
  questions?: Maybe<Array<Maybe<ComponentClickapoFaqQuestion>>>
  title: Scalars['String']['output']
}

export type ComponentClickapoSupplyPackageFaqQuestionsArgs = {
  filters?: InputMaybe<ComponentClickapoFaqQuestionFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoSupplyPackageFaqInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  questions?: InputMaybe<Array<InputMaybe<ComponentClickapoFaqQuestionInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoTips = {
  __typename?: 'ComponentClickapoTips'
  content?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mainTitle?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  tips?: Maybe<Array<Maybe<ComponentClickapoTipsItem>>>
}

export type ComponentClickapoTipsTipsArgs = {
  filters?: InputMaybe<ComponentClickapoTipsItemFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoTipsAnchorItem = {
  __typename?: 'ComponentClickapoTipsAnchorItem'
  id: Scalars['ID']['output']
  key?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoTipsAnchorItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoTipsAnchorItemFiltersInput>>>
  key?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoTipsAnchorItemFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoTipsAnchorItemFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoTipsAnchorList = {
  __typename?: 'ComponentClickapoTipsAnchorList'
  id: Scalars['ID']['output']
  tipsAnchorList?: Maybe<Array<Maybe<ComponentClickapoTipsAnchorItem>>>
}

export type ComponentClickapoTipsAnchorListTipsAnchorListArgs = {
  filters?: InputMaybe<ComponentClickapoTipsAnchorItemFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoTipsBannerBlock = {
  __typename?: 'ComponentClickapoTipsBannerBlock'
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileEntityResponse>
}

export type ComponentClickapoTipsInput = {
  content?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  mainTitle?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  tips?: InputMaybe<Array<InputMaybe<ComponentClickapoTipsItemInput>>>
}

export type ComponentClickapoTipsIntro = {
  __typename?: 'ComponentClickapoTipsIntro'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileEntityResponse>
  pageTitle: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ComponentClickapoTipsItem = {
  __typename?: 'ComponentClickapoTipsItem'
  content?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mainTitle?: Maybe<Scalars['String']['output']>
  products?: Maybe<Scalars['JSON']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoTipsItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoTipsItemFiltersInput>>>
  content?: InputMaybe<StringFilterInput>
  mainTitle?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentClickapoTipsItemFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoTipsItemFiltersInput>>>
  products?: InputMaybe<JsonFilterInput>
  subtitle?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoTipsItemInput = {
  content?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  mainTitle?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Scalars['JSON']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
}

export type ComponentClickapoTipsListBlock = {
  __typename?: 'ComponentClickapoTipsListBlock'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  tips?: Maybe<Array<Maybe<ComponentClickapoTipsListItem>>>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoTipsListBlockTipsArgs = {
  filters?: InputMaybe<ComponentClickapoTipsListItemFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentClickapoTipsListItem = {
  __typename?: 'ComponentClickapoTipsListItem'
  id: Scalars['ID']['output']
  text?: Maybe<Scalars['String']['output']>
}

export type ComponentClickapoTipsListItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClickapoTipsListItemFiltersInput>>>
  not?: InputMaybe<ComponentClickapoTipsListItemFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentClickapoTipsListItemFiltersInput>>>
  text?: InputMaybe<StringFilterInput>
}

export type ComponentClickapoTipsProductsBlock = {
  __typename?: 'ComponentClickapoTipsProductsBlock'
  anchorKey?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isSlider?: Maybe<Scalars['Boolean']['output']>
  products?: Maybe<Scalars['JSON']['output']>
  title: Scalars['String']['output']
}

export type ComponentCommercialBannersCommercialBannersSelection = {
  __typename?: 'ComponentCommercialBannersCommercialBannersSelection'
  customDisplay?: Maybe<CommercialBannerRelationResponseCollection>
  displayAll?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  useCustomDisplay?: Maybe<Scalars['Boolean']['output']>
}

export type ComponentCommercialBannersCommercialBannersSelectionCustomDisplayArgs = {
  filters?: InputMaybe<CommercialBannerFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentCommercialBannersCommercialBannersSelectionInput = {
  customDisplay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  displayAll?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  useCustomDisplay?: InputMaybe<Scalars['Boolean']['input']>
}

export type ComponentFooterFooterDeliveryInfo = {
  __typename?: 'ComponentFooterFooterDeliveryInfo'
  deliveryItem?: Maybe<Array<Maybe<ComponentFooterFooterDeliveryInfoItem>>>
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentFooterFooterDeliveryInfoDeliveryItemArgs = {
  filters?: InputMaybe<ComponentFooterFooterDeliveryInfoItemFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentFooterFooterDeliveryInfoInput = {
  deliveryItem?: InputMaybe<Array<InputMaybe<ComponentFooterFooterDeliveryInfoItemInput>>>
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentFooterFooterDeliveryInfoItem = {
  __typename?: 'ComponentFooterFooterDeliveryInfoItem'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  title?: Maybe<Scalars['String']['output']>
  whenToDisplay: Enum_Componentfooterfooterdeliveryinfoitem_Whentodisplay
}

export type ComponentFooterFooterDeliveryInfoItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentFooterFooterDeliveryInfoItemFiltersInput>>>
  description?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentFooterFooterDeliveryInfoItemFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentFooterFooterDeliveryInfoItemFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
  whenToDisplay?: InputMaybe<StringFilterInput>
}

export type ComponentFooterFooterDeliveryInfoItemInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  whenToDisplay?: InputMaybe<Enum_Componentfooterfooterdeliveryinfoitem_Whentodisplay>
}

export type ComponentFooterFooterHighDigits = {
  __typename?: 'ComponentFooterFooterHighDigits'
  additional?: Maybe<Scalars['String']['output']>
  highDigitItem?: Maybe<Array<Maybe<ComponentFooterHighDigitItem>>>
  id: Scalars['ID']['output']
}

export type ComponentFooterFooterHighDigitsHighDigitItemArgs = {
  filters?: InputMaybe<ComponentFooterHighDigitItemFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentFooterFooterHighDigitsInput = {
  additional?: InputMaybe<Scalars['String']['input']>
  highDigitItem?: InputMaybe<Array<InputMaybe<ComponentFooterHighDigitItemInput>>>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type ComponentFooterFooterInfoLinks = {
  __typename?: 'ComponentFooterFooterInfoLinks'
  id: Scalars['ID']['output']
  link?: Maybe<Array<Maybe<ComponentSharedLink>>>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentFooterFooterInfoLinksLinkArgs = {
  filters?: InputMaybe<ComponentSharedLinkFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentFooterFooterInfoLinksInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Array<InputMaybe<ComponentSharedLinkInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentFooterFooterPaymentInfo = {
  __typename?: 'ComponentFooterFooterPaymentInfo'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileRelationResponseCollection>
  title?: Maybe<Scalars['String']['output']>
  whenToDisplay: Enum_Componentfooterfooterpaymentinfo_Whentodisplay
}

export type ComponentFooterFooterPaymentInfoImageArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentFooterFooterPaymentInfoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentFooterFooterPaymentInfoFiltersInput>>>
  description?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentFooterFooterPaymentInfoFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentFooterFooterPaymentInfoFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
  whenToDisplay?: InputMaybe<StringFilterInput>
}

export type ComponentFooterFooterPaymentInfoInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  title?: InputMaybe<Scalars['String']['input']>
  whenToDisplay?: InputMaybe<Enum_Componentfooterfooterpaymentinfo_Whentodisplay>
}

export type ComponentFooterFooterSocialNetworkItem = {
  __typename?: 'ComponentFooterFooterSocialNetworkItem'
  id: Scalars['ID']['output']
  network?: Maybe<Enum_Componentfooterfootersocialnetworkitem_Network>
  url?: Maybe<Scalars['String']['output']>
}

export type ComponentFooterFooterSocialNetworkItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentFooterFooterSocialNetworkItemFiltersInput>>>
  network?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentFooterFooterSocialNetworkItemFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentFooterFooterSocialNetworkItemFiltersInput>>>
  url?: InputMaybe<StringFilterInput>
}

export type ComponentFooterFooterSocialNetworkItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  network?: InputMaybe<Enum_Componentfooterfootersocialnetworkitem_Network>
  url?: InputMaybe<Scalars['String']['input']>
}

export type ComponentFooterFooterSocialNetworks = {
  __typename?: 'ComponentFooterFooterSocialNetworks'
  id: Scalars['ID']['output']
  socialNetworkItem?: Maybe<Array<Maybe<ComponentFooterFooterSocialNetworkItem>>>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentFooterFooterSocialNetworksSocialNetworkItemArgs = {
  filters?: InputMaybe<ComponentFooterFooterSocialNetworkItemFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentFooterFooterSocialNetworksInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  socialNetworkItem?: InputMaybe<Array<InputMaybe<ComponentFooterFooterSocialNetworkItemInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentFooterHighDigitItem = {
  __typename?: 'ComponentFooterHighDigitItem'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type ComponentFooterHighDigitItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentFooterHighDigitItemFiltersInput>>>
  description?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentFooterHighDigitItemFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentFooterHighDigitItemFiltersInput>>>
}

export type ComponentFooterHighDigitItemInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type ComponentMagazineApofinderConfig = {
  __typename?: 'ComponentMagazineApofinderConfig'
  filtersToHide?: Maybe<ComponentMagazineApofinderFiltersToHide>
  id: Scalars['ID']['output']
  options?: Maybe<ComponentMagazineApofinderOptions>
  settings?: Maybe<ComponentMagazineApofinderSettings>
  utm?: Maybe<ComponentMagazineApofinderUtm>
}

export type ComponentMagazineApofinderConfigInput = {
  filtersToHide?: InputMaybe<ComponentMagazineApofinderFiltersToHideInput>
  id?: InputMaybe<Scalars['ID']['input']>
  options?: InputMaybe<ComponentMagazineApofinderOptionsInput>
  settings?: InputMaybe<ComponentMagazineApofinderSettingsInput>
  utm?: InputMaybe<ComponentMagazineApofinderUtmInput>
}

export type ComponentMagazineApofinderFiltersToHide = {
  __typename?: 'ComponentMagazineApofinderFiltersToHide'
  delivery?: Maybe<Scalars['Boolean']['output']>
  expressDelivery?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  magazines?: Maybe<Scalars['Boolean']['output']>
  openPharmacies?: Maybe<Scalars['Boolean']['output']>
}

export type ComponentMagazineApofinderFiltersToHideInput = {
  delivery?: InputMaybe<Scalars['Boolean']['input']>
  expressDelivery?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  magazines?: InputMaybe<Scalars['Boolean']['input']>
  openPharmacies?: InputMaybe<Scalars['Boolean']['input']>
}

export type ComponentMagazineApofinderOptions = {
  __typename?: 'ComponentMagazineApofinderOptions'
  activateAllPharmaciesFilter?: Maybe<Scalars['Boolean']['output']>
  consentActive?: Maybe<Scalars['Boolean']['output']>
  couponCode?: Maybe<Scalars['String']['output']>
  customUrl?: Maybe<Scalars['String']['output']>
  delivery?: Maybe<Scalars['Boolean']['output']>
  destination?: Maybe<Scalars['String']['output']>
  expressDelivery?: Maybe<Scalars['Boolean']['output']>
  geolocation?: Maybe<Scalars['Boolean']['output']>
  headline?: Maybe<Scalars['String']['output']>
  hideMagazines?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  lat?: Maybe<Scalars['String']['output']>
  lng?: Maybe<Scalars['String']['output']>
  magazines?: Maybe<Scalars['String']['output']>
  manufacturer?: Maybe<Scalars['String']['output']>
  needsGoogleConsent?: Maybe<Scalars['Boolean']['output']>
  open?: Maybe<Scalars['Boolean']['output']>
  openLinksInNewWindow?: Maybe<Scalars['Boolean']['output']>
  pcase?: Maybe<Scalars['String']['output']>
  pharmaciesPerPage?: Maybe<Scalars['String']['output']>
  productCategory?: Maybe<Scalars['String']['output']>
  products?: Maybe<Scalars['String']['output']>
  pzn?: Maybe<Scalars['String']['output']>
  query?: Maybe<Scalars['String']['output']>
  recommendedProducts?: Maybe<Scalars['String']['output']>
  showAllPharmacies?: Maybe<Scalars['Boolean']['output']>
  showAllPharmaciesFilter?: Maybe<Scalars['Boolean']['output']>
  showRequestButton?: Maybe<Scalars['Boolean']['output']>
  test?: Maybe<Scalars['Boolean']['output']>
  text?: Maybe<Scalars['String']['output']>
  view?: Maybe<Scalars['String']['output']>
  wirkstoffe?: Maybe<Scalars['String']['output']>
}

export type ComponentMagazineApofinderOptionsInput = {
  activateAllPharmaciesFilter?: InputMaybe<Scalars['Boolean']['input']>
  consentActive?: InputMaybe<Scalars['Boolean']['input']>
  couponCode?: InputMaybe<Scalars['String']['input']>
  customUrl?: InputMaybe<Scalars['String']['input']>
  delivery?: InputMaybe<Scalars['Boolean']['input']>
  destination?: InputMaybe<Scalars['String']['input']>
  expressDelivery?: InputMaybe<Scalars['Boolean']['input']>
  geolocation?: InputMaybe<Scalars['Boolean']['input']>
  headline?: InputMaybe<Scalars['String']['input']>
  hideMagazines?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  lat?: InputMaybe<Scalars['String']['input']>
  lng?: InputMaybe<Scalars['String']['input']>
  magazines?: InputMaybe<Scalars['String']['input']>
  manufacturer?: InputMaybe<Scalars['String']['input']>
  needsGoogleConsent?: InputMaybe<Scalars['Boolean']['input']>
  open?: InputMaybe<Scalars['Boolean']['input']>
  openLinksInNewWindow?: InputMaybe<Scalars['Boolean']['input']>
  pcase?: InputMaybe<Scalars['String']['input']>
  pharmaciesPerPage?: InputMaybe<Scalars['String']['input']>
  productCategory?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Scalars['String']['input']>
  pzn?: InputMaybe<Scalars['String']['input']>
  query?: InputMaybe<Scalars['String']['input']>
  recommendedProducts?: InputMaybe<Scalars['String']['input']>
  showAllPharmacies?: InputMaybe<Scalars['Boolean']['input']>
  showAllPharmaciesFilter?: InputMaybe<Scalars['Boolean']['input']>
  showRequestButton?: InputMaybe<Scalars['Boolean']['input']>
  test?: InputMaybe<Scalars['Boolean']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  view?: InputMaybe<Scalars['String']['input']>
  wirkstoffe?: InputMaybe<Scalars['String']['input']>
}

export type ComponentMagazineApofinderSettings = {
  __typename?: 'ComponentMagazineApofinderSettings'
  filterButtonsRadius?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  locationMarkerIcon?: Maybe<Scalars['String']['output']>
  pharmacyButtonColor?: Maybe<Scalars['String']['output']>
  pharmacyButtonRadius?: Maybe<Scalars['String']['output']>
  pharmacyClosedColor?: Maybe<Scalars['String']['output']>
  pharmacyMarkerIcon?: Maybe<Scalars['String']['output']>
  pharmacyOpenColor?: Maybe<Scalars['String']['output']>
  primaryColor?: Maybe<Scalars['String']['output']>
  primaryFont?: Maybe<Scalars['String']['output']>
  primaryFontFamily?: Maybe<Scalars['String']['output']>
  searchButtonColor?: Maybe<Scalars['String']['output']>
  secondaryColor?: Maybe<Scalars['String']['output']>
}

export type ComponentMagazineApofinderSettingsInput = {
  filterButtonsRadius?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  locationMarkerIcon?: InputMaybe<Scalars['String']['input']>
  pharmacyButtonColor?: InputMaybe<Scalars['String']['input']>
  pharmacyButtonRadius?: InputMaybe<Scalars['String']['input']>
  pharmacyClosedColor?: InputMaybe<Scalars['String']['input']>
  pharmacyMarkerIcon?: InputMaybe<Scalars['String']['input']>
  pharmacyOpenColor?: InputMaybe<Scalars['String']['input']>
  primaryColor?: InputMaybe<Scalars['String']['input']>
  primaryFont?: InputMaybe<Scalars['String']['input']>
  primaryFontFamily?: InputMaybe<Scalars['String']['input']>
  searchButtonColor?: InputMaybe<Scalars['String']['input']>
  secondaryColor?: InputMaybe<Scalars['String']['input']>
}

export type ComponentMagazineApofinderUtm = {
  __typename?: 'ComponentMagazineApofinderUtm'
  campaign?: Maybe<Scalars['String']['output']>
  content?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  medium?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  term?: Maybe<Scalars['String']['output']>
}

export type ComponentMagazineApofinderUtmInput = {
  campaign?: InputMaybe<Scalars['String']['input']>
  content?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  medium?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  term?: InputMaybe<Scalars['String']['input']>
}

export type ComponentMagazineHomepageDeviceBanner = {
  __typename?: 'ComponentMagazineHomepageDeviceBanner'
  href?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileEntityResponse>
}

export type ComponentMagazineHomepageDeviceBannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMagazineHomepageDeviceBannerFiltersInput>>>
  href?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentMagazineHomepageDeviceBannerFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentMagazineHomepageDeviceBannerFiltersInput>>>
}

export type ComponentMagazineHomepageDeviceBannerInput = {
  href?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
}

export type ComponentMagazineHomepageMagazineBanner = {
  __typename?: 'ComponentMagazineHomepageMagazineBanner'
  desktop?: Maybe<UploadFileEntityResponse>
  id: Scalars['ID']['output']
  mobile?: Maybe<UploadFileEntityResponse>
}

export type ComponentMagazineSliderBannersCommercial = {
  __typename?: 'ComponentMagazineSliderBannersCommercial'
  desktop?: Maybe<Array<Maybe<ComponentMagazineHomepageDeviceBanner>>>
  id: Scalars['ID']['output']
  mobile?: Maybe<Array<Maybe<ComponentMagazineHomepageDeviceBanner>>>
}

export type ComponentMagazineSliderBannersCommercialDesktopArgs = {
  filters?: InputMaybe<ComponentMagazineHomepageDeviceBannerFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentMagazineSliderBannersCommercialMobileArgs = {
  filters?: InputMaybe<ComponentMagazineHomepageDeviceBannerFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentMagazineSliderBannersCommercialInput = {
  desktop?: InputMaybe<Array<InputMaybe<ComponentMagazineHomepageDeviceBannerInput>>>
  id?: InputMaybe<Scalars['ID']['input']>
  mobile?: InputMaybe<Array<InputMaybe<ComponentMagazineHomepageDeviceBannerInput>>>
}

export type ComponentMainMenuMainMenuCategory = {
  __typename?: 'ComponentMainMenuMainMenuCategory'
  id: Scalars['ID']['output']
  link?: Maybe<Array<Maybe<ComponentSharedLink>>>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentMainMenuMainMenuCategoryLinkArgs = {
  filters?: InputMaybe<ComponentSharedLinkFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentMainMenuMainMenuCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainMenuMainMenuCategoryFiltersInput>>>
  link?: InputMaybe<ComponentSharedLinkFiltersInput>
  not?: InputMaybe<ComponentMainMenuMainMenuCategoryFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentMainMenuMainMenuCategoryFiltersInput>>>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentMainMenuMainMenuCategoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Array<InputMaybe<ComponentSharedLinkInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentMarkenshopMarkenshopSelection = {
  __typename?: 'ComponentMarkenshopMarkenshopSelection'
  button?: Maybe<ComponentSharedButton1>
  customDisplay?: Maybe<MarkenshopRelationResponseCollection>
  displayAll?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  title: Scalars['String']['output']
  useCustomDisplay?: Maybe<Scalars['Boolean']['output']>
}

export type ComponentMarkenshopMarkenshopSelectionCustomDisplayArgs = {
  filters?: InputMaybe<MarkenshopFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentMarkenshopMarkenshopSelectionInput = {
  button?: InputMaybe<ComponentSharedButton1Input>
  customDisplay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  displayAll?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  useCustomDisplay?: InputMaybe<Scalars['Boolean']['input']>
}

export type ComponentSdkCardLinkConfiguration = {
  __typename?: 'ComponentSdkCardLinkConfiguration'
  errorBannerMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isAndroidErrorBannerShown: Scalars['Boolean']['output']
  isErrorBannerShown: Scalars['Boolean']['output']
  isIosErrorBannerShown: Scalars['Boolean']['output']
  isSaveCardEnabled: Scalars['Boolean']['output']
  nfcPositions?: Maybe<Scalars['JSON']['output']>
}

export type ComponentSdkCardLinkConfigurationInput = {
  errorBannerMessage?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  isAndroidErrorBannerShown?: InputMaybe<Scalars['Boolean']['input']>
  isErrorBannerShown?: InputMaybe<Scalars['Boolean']['input']>
  isIosErrorBannerShown?: InputMaybe<Scalars['Boolean']['input']>
  isSaveCardEnabled?: InputMaybe<Scalars['Boolean']['input']>
  nfcPositions?: InputMaybe<Scalars['JSON']['input']>
}

export type ComponentSdkClient = {
  __typename?: 'ComponentSdkClient'
  forceUpdate?: Maybe<ComponentSdkForceUpdate>
  id: Scalars['ID']['output']
  identifier: Scalars['String']['output']
  legalText?: Maybe<ComponentSdkLegalText>
  name?: Maybe<Scalars['String']['output']>
  showOnboarding: Scalars['Boolean']['output']
  vendorIdentifier?: Maybe<Scalars['String']['output']>
}

export type ComponentSdkClientFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSdkClientFiltersInput>>>
  forceUpdate?: InputMaybe<ComponentSdkForceUpdateFiltersInput>
  identifier?: InputMaybe<StringFilterInput>
  legalText?: InputMaybe<ComponentSdkLegalTextFiltersInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentSdkClientFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSdkClientFiltersInput>>>
  showOnboarding?: InputMaybe<BooleanFilterInput>
  vendorIdentifier?: InputMaybe<StringFilterInput>
}

export type ComponentSdkClientInput = {
  forceUpdate?: InputMaybe<ComponentSdkForceUpdateInput>
  id?: InputMaybe<Scalars['ID']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
  legalText?: InputMaybe<ComponentSdkLegalTextInput>
  name?: InputMaybe<Scalars['String']['input']>
  showOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  vendorIdentifier?: InputMaybe<Scalars['String']['input']>
}

export type ComponentSdkForceUpdate = {
  __typename?: 'ComponentSdkForceUpdate'
  id: Scalars['ID']['output']
  message: Scalars['String']['output']
  minimumVersion: Scalars['String']['output']
  type: Enum_Componentsdkforceupdate_Type
}

export type ComponentSdkForceUpdateFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSdkForceUpdateFiltersInput>>>
  message?: InputMaybe<StringFilterInput>
  minimumVersion?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentSdkForceUpdateFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSdkForceUpdateFiltersInput>>>
  type?: InputMaybe<StringFilterInput>
}

export type ComponentSdkForceUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  minimumVersion?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Enum_Componentsdkforceupdate_Type>
}

export type ComponentSdkInfrastructure = {
  __typename?: 'ComponentSdkInfrastructure'
  id: Scalars['ID']['output']
  ios?: Maybe<ComponentSdkInfrastructureIos>
}

export type ComponentSdkInfrastructureInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  ios?: InputMaybe<ComponentSdkInfrastructureIosInput>
}

export type ComponentSdkInfrastructureIos = {
  __typename?: 'ComponentSdkInfrastructureIos'
  id: Scalars['ID']['output']
  metaData?: Maybe<Scalars['String']['output']>
  metaDataException?: Maybe<Scalars['String']['output']>
}

export type ComponentSdkInfrastructureIosInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  metaData?: InputMaybe<Scalars['String']['input']>
  metaDataException?: InputMaybe<Scalars['String']['input']>
}

export type ComponentSdkLegalDocuments = {
  __typename?: 'ComponentSdkLegalDocuments'
  clientId: Scalars['String']['output']
  content: Scalars['String']['output']
  id: Scalars['ID']['output']
  identifier: Scalars['String']['output']
  version: Scalars['String']['output']
}

export type ComponentSdkLegalDocumentsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSdkLegalDocumentsFiltersInput>>>
  clientId?: InputMaybe<StringFilterInput>
  content?: InputMaybe<StringFilterInput>
  identifier?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentSdkLegalDocumentsFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSdkLegalDocumentsFiltersInput>>>
  version?: InputMaybe<StringFilterInput>
}

export type ComponentSdkLegalDocumentsInput = {
  clientId?: InputMaybe<Scalars['String']['input']>
  content?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

export type ComponentSdkLegalText = {
  __typename?: 'ComponentSdkLegalText'
  areLegalDocumentsMandatory: Scalars['Boolean']['output']
  content: Scalars['String']['output']
  id: Scalars['ID']['output']
  isPrivacyMandatory: Scalars['Boolean']['output']
  isTermsOfServiceMandatory: Scalars['Boolean']['output']
}

export type ComponentSdkLegalTextFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSdkLegalTextFiltersInput>>>
  areLegalDocumentsMandatory?: InputMaybe<BooleanFilterInput>
  content?: InputMaybe<StringFilterInput>
  isPrivacyMandatory?: InputMaybe<BooleanFilterInput>
  isTermsOfServiceMandatory?: InputMaybe<BooleanFilterInput>
  not?: InputMaybe<ComponentSdkLegalTextFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSdkLegalTextFiltersInput>>>
}

export type ComponentSdkLegalTextInput = {
  areLegalDocumentsMandatory?: InputMaybe<Scalars['Boolean']['input']>
  content?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  isPrivacyMandatory?: InputMaybe<Scalars['Boolean']['input']>
  isTermsOfServiceMandatory?: InputMaybe<Scalars['Boolean']['input']>
}

export type ComponentSdkOnboardingPage = {
  __typename?: 'ComponentSdkOnboardingPage'
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileEntityResponse>
  sections?: Maybe<Array<Maybe<ComponentSdkOnboardingSection>>>
  title?: Maybe<Scalars['String']['output']>
}

export type ComponentSdkOnboardingPageSectionsArgs = {
  filters?: InputMaybe<ComponentSdkOnboardingSectionFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentSdkOnboardingPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSdkOnboardingPageFiltersInput>>>
  not?: InputMaybe<ComponentSdkOnboardingPageFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSdkOnboardingPageFiltersInput>>>
  sections?: InputMaybe<ComponentSdkOnboardingSectionFiltersInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentSdkOnboardingPageInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  sections?: InputMaybe<Array<InputMaybe<ComponentSdkOnboardingSectionInput>>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentSdkOnboardingSection = {
  __typename?: 'ComponentSdkOnboardingSection'
  id: Scalars['ID']['output']
  text: Scalars['String']['output']
}

export type ComponentSdkOnboardingSectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSdkOnboardingSectionFiltersInput>>>
  not?: InputMaybe<ComponentSdkOnboardingSectionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSdkOnboardingSectionFiltersInput>>>
  text?: InputMaybe<StringFilterInput>
}

export type ComponentSdkOnboardingSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type ComponentServicesServiceBannersSelection = {
  __typename?: 'ComponentServicesServiceBannersSelection'
  customDisplay?: Maybe<ServiceBannerRelationResponseCollection>
  displayAll?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  useCustomDisplay?: Maybe<Scalars['Boolean']['output']>
}

export type ComponentServicesServiceBannersSelectionCustomDisplayArgs = {
  filters?: InputMaybe<ServiceBannerFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentServicesServiceBannersSelectionInput = {
  customDisplay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  displayAll?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  useCustomDisplay?: InputMaybe<Scalars['Boolean']['input']>
}

export type ComponentSharedButton1 = {
  __typename?: 'ComponentSharedButton1'
  id: Scalars['ID']['output']
  label?: Maybe<Scalars['String']['output']>
  link?: Maybe<Scalars['String']['output']>
}

export type ComponentSharedButton1FiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedButton1FiltersInput>>>
  label?: InputMaybe<StringFilterInput>
  link?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentSharedButton1FiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSharedButton1FiltersInput>>>
}

export type ComponentSharedButton1Input = {
  id?: InputMaybe<Scalars['ID']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  link?: InputMaybe<Scalars['String']['input']>
}

export type ComponentSharedLink = {
  __typename?: 'ComponentSharedLink'
  authDisplay?: Maybe<Enum_Componentsharedlink_Authdisplay>
  elementId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  newTab?: Maybe<Scalars['Boolean']['output']>
  text?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type ComponentSharedLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLinkFiltersInput>>>
  authDisplay?: InputMaybe<StringFilterInput>
  elementId?: InputMaybe<StringFilterInput>
  newTab?: InputMaybe<BooleanFilterInput>
  not?: InputMaybe<ComponentSharedLinkFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLinkFiltersInput>>>
  text?: InputMaybe<StringFilterInput>
  url?: InputMaybe<StringFilterInput>
}

export type ComponentSharedLinkInput = {
  authDisplay?: InputMaybe<Enum_Componentsharedlink_Authdisplay>
  elementId?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  newTab?: InputMaybe<Scalars['Boolean']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type ComponentSharedMetaSocial = {
  __typename?: 'ComponentSharedMetaSocial'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  image?: Maybe<UploadFileEntityResponse>
  socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork
  title: Scalars['String']['output']
}

export type ComponentSharedMetaSocialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>
  description?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ComponentSharedMetaSocialFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>
  socialNetwork?: InputMaybe<StringFilterInput>
  title?: InputMaybe<StringFilterInput>
}

export type ComponentSharedMetaSocialInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  socialNetwork?: InputMaybe<Enum_Componentsharedmetasocial_Socialnetwork>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ComponentSharedPcase = {
  __typename?: 'ComponentSharedPcase'
  id: Scalars['ID']['output']
  pcase: Scalars['String']['output']
}

export type ComponentSharedPcaseFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedPcaseFiltersInput>>>
  not?: InputMaybe<ComponentSharedPcaseFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ComponentSharedPcaseFiltersInput>>>
  pcase?: InputMaybe<StringFilterInput>
}

export type ComponentSharedPcaseInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  pcase?: InputMaybe<Scalars['String']['input']>
}

export type ComponentSharedSeo = {
  __typename?: 'ComponentSharedSeo'
  canonicalURL?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  keywords?: Maybe<Scalars['String']['output']>
  metaDescription: Scalars['String']['output']
  metaImage: UploadFileEntityResponse
  metaRobots?: Maybe<Scalars['String']['output']>
  metaSocial?: Maybe<Array<Maybe<ComponentSharedMetaSocial>>>
  metaTitle: Scalars['String']['output']
  metaViewport?: Maybe<Scalars['String']['output']>
  structuredData?: Maybe<Scalars['JSON']['output']>
}

export type ComponentSharedSeoMetaSocialArgs = {
  filters?: InputMaybe<ComponentSharedMetaSocialFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentSharedSeoInput = {
  canonicalURL?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  keywords?: InputMaybe<Scalars['String']['input']>
  metaDescription?: InputMaybe<Scalars['String']['input']>
  metaImage?: InputMaybe<Scalars['ID']['input']>
  metaRobots?: InputMaybe<Scalars['String']['input']>
  metaSocial?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialInput>>>
  metaTitle?: InputMaybe<Scalars['String']['input']>
  metaViewport?: InputMaybe<Scalars['String']['input']>
  structuredData?: InputMaybe<Scalars['JSON']['input']>
}

export type ComponentThemenshopThemenshopSelection = {
  __typename?: 'ComponentThemenshopThemenshopSelection'
  button: ComponentSharedButton1
  customDisplay?: Maybe<ThemenshopRelationResponseCollection>
  displayAll?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  title: Scalars['String']['output']
  useCustomDisplay?: Maybe<Scalars['Boolean']['output']>
}

export type ComponentThemenshopThemenshopSelectionCustomDisplayArgs = {
  filters?: InputMaybe<ThemenshopFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ComponentThemenshopThemenshopSelectionInput = {
  button?: InputMaybe<ComponentSharedButton1Input>
  customDisplay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  displayAll?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  useCustomDisplay?: InputMaybe<Scalars['Boolean']['input']>
}

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  contains?: InputMaybe<Scalars['DateTime']['input']>
  containsi?: InputMaybe<Scalars['DateTime']['input']>
  endsWith?: InputMaybe<Scalars['DateTime']['input']>
  eq?: InputMaybe<Scalars['DateTime']['input']>
  eqi?: InputMaybe<Scalars['DateTime']['input']>
  gt?: InputMaybe<Scalars['DateTime']['input']>
  gte?: InputMaybe<Scalars['DateTime']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  lt?: InputMaybe<Scalars['DateTime']['input']>
  lte?: InputMaybe<Scalars['DateTime']['input']>
  ne?: InputMaybe<Scalars['DateTime']['input']>
  nei?: InputMaybe<Scalars['DateTime']['input']>
  not?: InputMaybe<DateTimeFilterInput>
  notContains?: InputMaybe<Scalars['DateTime']['input']>
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  startsWith?: InputMaybe<Scalars['DateTime']['input']>
}

export type DynamicAccessibility = {
  __typename?: 'DynamicAccessibility'
  content?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<DynamicAccessibilityRelationResponseCollection>
  partnersRelated?: Maybe<Scalars['Boolean']['output']>
  pharmacyRelated?: Maybe<Scalars['Boolean']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version: Scalars['String']['output']
}

export type DynamicAccessibilityLocalizationsArgs = {
  filters?: InputMaybe<DynamicAccessibilityFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type DynamicAccessibilityEntity = {
  __typename?: 'DynamicAccessibilityEntity'
  attributes?: Maybe<DynamicAccessibility>
  id?: Maybe<Scalars['ID']['output']>
}

export type DynamicAccessibilityEntityResponse = {
  __typename?: 'DynamicAccessibilityEntityResponse'
  data?: Maybe<DynamicAccessibilityEntity>
}

export type DynamicAccessibilityEntityResponseCollection = {
  __typename?: 'DynamicAccessibilityEntityResponseCollection'
  data: Array<DynamicAccessibilityEntity>
  meta: ResponseCollectionMeta
}

export type DynamicAccessibilityFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DynamicAccessibilityFiltersInput>>>
  content?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<DynamicAccessibilityFiltersInput>
  not?: InputMaybe<DynamicAccessibilityFiltersInput>
  or?: InputMaybe<Array<InputMaybe<DynamicAccessibilityFiltersInput>>>
  partnersRelated?: InputMaybe<BooleanFilterInput>
  pharmacyRelated?: InputMaybe<BooleanFilterInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  version?: InputMaybe<StringFilterInput>
}

export type DynamicAccessibilityInput = {
  content?: InputMaybe<Scalars['String']['input']>
  partnersRelated?: InputMaybe<Scalars['Boolean']['input']>
  pharmacyRelated?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

export type DynamicAccessibilityRelationResponseCollection = {
  __typename?: 'DynamicAccessibilityRelationResponseCollection'
  data: Array<DynamicAccessibilityEntity>
}

export type DynamicDataPrivacy = {
  __typename?: 'DynamicDataPrivacy'
  content?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<DynamicDataPrivacyRelationResponseCollection>
  partnersRelated?: Maybe<Scalars['Boolean']['output']>
  pharmacyRelated?: Maybe<Scalars['Boolean']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version: Scalars['String']['output']
}

export type DynamicDataPrivacyLocalizationsArgs = {
  filters?: InputMaybe<DynamicDataPrivacyFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type DynamicDataPrivacyEntity = {
  __typename?: 'DynamicDataPrivacyEntity'
  attributes?: Maybe<DynamicDataPrivacy>
  id?: Maybe<Scalars['ID']['output']>
}

export type DynamicDataPrivacyEntityResponse = {
  __typename?: 'DynamicDataPrivacyEntityResponse'
  data?: Maybe<DynamicDataPrivacyEntity>
}

export type DynamicDataPrivacyEntityResponseCollection = {
  __typename?: 'DynamicDataPrivacyEntityResponseCollection'
  data: Array<DynamicDataPrivacyEntity>
  meta: ResponseCollectionMeta
}

export type DynamicDataPrivacyFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DynamicDataPrivacyFiltersInput>>>
  content?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<DynamicDataPrivacyFiltersInput>
  not?: InputMaybe<DynamicDataPrivacyFiltersInput>
  or?: InputMaybe<Array<InputMaybe<DynamicDataPrivacyFiltersInput>>>
  partnersRelated?: InputMaybe<BooleanFilterInput>
  pharmacyRelated?: InputMaybe<BooleanFilterInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  version?: InputMaybe<StringFilterInput>
}

export type DynamicDataPrivacyInput = {
  content?: InputMaybe<Scalars['String']['input']>
  partnersRelated?: InputMaybe<Scalars['Boolean']['input']>
  pharmacyRelated?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

export type DynamicDataPrivacyRelationResponseCollection = {
  __typename?: 'DynamicDataPrivacyRelationResponseCollection'
  data: Array<DynamicDataPrivacyEntity>
}

export type DynamicImprint = {
  __typename?: 'DynamicImprint'
  content: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<DynamicImprintRelationResponseCollection>
  partnersRelated?: Maybe<Scalars['Boolean']['output']>
  pharmacyRelated?: Maybe<Scalars['Boolean']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version: Scalars['String']['output']
}

export type DynamicImprintLocalizationsArgs = {
  filters?: InputMaybe<DynamicImprintFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type DynamicImprintEntity = {
  __typename?: 'DynamicImprintEntity'
  attributes?: Maybe<DynamicImprint>
  id?: Maybe<Scalars['ID']['output']>
}

export type DynamicImprintEntityResponse = {
  __typename?: 'DynamicImprintEntityResponse'
  data?: Maybe<DynamicImprintEntity>
}

export type DynamicImprintEntityResponseCollection = {
  __typename?: 'DynamicImprintEntityResponseCollection'
  data: Array<DynamicImprintEntity>
  meta: ResponseCollectionMeta
}

export type DynamicImprintFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DynamicImprintFiltersInput>>>
  content?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<DynamicImprintFiltersInput>
  not?: InputMaybe<DynamicImprintFiltersInput>
  or?: InputMaybe<Array<InputMaybe<DynamicImprintFiltersInput>>>
  partnersRelated?: InputMaybe<BooleanFilterInput>
  pharmacyRelated?: InputMaybe<BooleanFilterInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  version?: InputMaybe<StringFilterInput>
}

export type DynamicImprintInput = {
  content?: InputMaybe<Scalars['String']['input']>
  partnersRelated?: InputMaybe<Scalars['Boolean']['input']>
  pharmacyRelated?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

export type DynamicImprintRelationResponseCollection = {
  __typename?: 'DynamicImprintRelationResponseCollection'
  data: Array<DynamicImprintEntity>
}

export type DynamicTermsAndCondition = {
  __typename?: 'DynamicTermsAndCondition'
  content?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<DynamicTermsAndConditionRelationResponseCollection>
  partnersRelated?: Maybe<Scalars['Boolean']['output']>
  pharmacyRelated?: Maybe<Scalars['Boolean']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  version?: Maybe<Scalars['String']['output']>
}

export type DynamicTermsAndConditionLocalizationsArgs = {
  filters?: InputMaybe<DynamicTermsAndConditionFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type DynamicTermsAndConditionEntity = {
  __typename?: 'DynamicTermsAndConditionEntity'
  attributes?: Maybe<DynamicTermsAndCondition>
  id?: Maybe<Scalars['ID']['output']>
}

export type DynamicTermsAndConditionEntityResponse = {
  __typename?: 'DynamicTermsAndConditionEntityResponse'
  data?: Maybe<DynamicTermsAndConditionEntity>
}

export type DynamicTermsAndConditionEntityResponseCollection = {
  __typename?: 'DynamicTermsAndConditionEntityResponseCollection'
  data: Array<DynamicTermsAndConditionEntity>
  meta: ResponseCollectionMeta
}

export type DynamicTermsAndConditionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DynamicTermsAndConditionFiltersInput>>>
  content?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<DynamicTermsAndConditionFiltersInput>
  not?: InputMaybe<DynamicTermsAndConditionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<DynamicTermsAndConditionFiltersInput>>>
  partnersRelated?: InputMaybe<BooleanFilterInput>
  pharmacyRelated?: InputMaybe<BooleanFilterInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  version?: InputMaybe<StringFilterInput>
}

export type DynamicTermsAndConditionInput = {
  content?: InputMaybe<Scalars['String']['input']>
  partnersRelated?: InputMaybe<Scalars['Boolean']['input']>
  pharmacyRelated?: InputMaybe<Scalars['Boolean']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  version?: InputMaybe<Scalars['String']['input']>
}

export type DynamicTermsAndConditionRelationResponseCollection = {
  __typename?: 'DynamicTermsAndConditionRelationResponseCollection'
  data: Array<DynamicTermsAndConditionEntity>
}

export enum Enum_Componentapofinderadvertisements_Type {
  Google = 'google',
  Image = 'image',
}

export enum Enum_Componentapofinderfindpharmacychoice_Display {
  Buttons = 'buttons',
  Input = 'input',
}

export enum Enum_Componentapofinderinfoblock_Imageposition {
  Left = 'left',
  Right = 'right',
}

export enum Enum_Componentfooterfooterdeliveryinfoitem_Whentodisplay {
  Always = 'always',
  NoPharmacy = 'noPharmacy',
  PharmacySelected = 'pharmacySelected',
}

export enum Enum_Componentfooterfooterpaymentinfo_Whentodisplay {
  Always = 'always',
  NoPharmacy = 'noPharmacy',
  PharmacyWithPayments = 'pharmacyWithPayments',
  PharmacyWithoutPayments = 'pharmacyWithoutPayments',
}

export enum Enum_Componentfooterfootersocialnetworkitem_Network {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Youtube = 'youtube',
}

export enum Enum_Componentsdkforceupdate_Type {
  Hard = 'hard',
  Soft = 'soft',
}

export enum Enum_Componentsharedlink_Authdisplay {
  Always = 'always',
  Anonymous = 'anonymous',
  Authenticated = 'authenticated',
}

export enum Enum_Componentsharedmetasocial_Socialnetwork {
  Facebook = 'Facebook',
  Twitter = 'Twitter',
}

export type EmailBanner = {
  __typename?: 'EmailBanner'
  altText?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  image: UploadFileEntityResponse
  link?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  templates: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type EmailBannerEntity = {
  __typename?: 'EmailBannerEntity'
  attributes?: Maybe<EmailBanner>
  id?: Maybe<Scalars['ID']['output']>
}

export type EmailBannerEntityResponse = {
  __typename?: 'EmailBannerEntityResponse'
  data?: Maybe<EmailBannerEntity>
}

export type EmailBannerEntityResponseCollection = {
  __typename?: 'EmailBannerEntityResponseCollection'
  data: Array<EmailBannerEntity>
  meta: ResponseCollectionMeta
}

export type EmailBannerFiltersInput = {
  altText?: InputMaybe<StringFilterInput>
  and?: InputMaybe<Array<InputMaybe<EmailBannerFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  link?: InputMaybe<StringFilterInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<EmailBannerFiltersInput>
  or?: InputMaybe<Array<InputMaybe<EmailBannerFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  templates?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type EmailBannerInput = {
  altText?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  templates?: InputMaybe<Scalars['String']['input']>
}

export type Error = {
  __typename?: 'Error'
  code: Scalars['String']['output']
  message?: Maybe<Scalars['String']['output']>
}

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>
  caption?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  contains?: InputMaybe<Scalars['Float']['input']>
  containsi?: InputMaybe<Scalars['Float']['input']>
  endsWith?: InputMaybe<Scalars['Float']['input']>
  eq?: InputMaybe<Scalars['Float']['input']>
  eqi?: InputMaybe<Scalars['Float']['input']>
  gt?: InputMaybe<Scalars['Float']['input']>
  gte?: InputMaybe<Scalars['Float']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  lt?: InputMaybe<Scalars['Float']['input']>
  lte?: InputMaybe<Scalars['Float']['input']>
  ne?: InputMaybe<Scalars['Float']['input']>
  nei?: InputMaybe<Scalars['Float']['input']>
  not?: InputMaybe<FloatFilterInput>
  notContains?: InputMaybe<Scalars['Float']['input']>
  notContainsi?: InputMaybe<Scalars['Float']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  startsWith?: InputMaybe<Scalars['Float']['input']>
}

export type Footer = {
  __typename?: 'Footer'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  deliveryInfo?: Maybe<ComponentFooterFooterDeliveryInfo>
  highDigits?: Maybe<ComponentFooterFooterHighDigits>
  infoLinks?: Maybe<ComponentFooterFooterInfoLinks>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<FooterRelationResponseCollection>
  paymentInfo?: Maybe<Array<Maybe<ComponentFooterFooterPaymentInfo>>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  socialNetworks?: Maybe<ComponentFooterFooterSocialNetworks>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type FooterLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>
}

export type FooterPaymentInfoArgs = {
  filters?: InputMaybe<ComponentFooterFooterPaymentInfoFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type FooterEntity = {
  __typename?: 'FooterEntity'
  attributes?: Maybe<Footer>
  id?: Maybe<Scalars['ID']['output']>
}

export type FooterEntityResponse = {
  __typename?: 'FooterEntityResponse'
  data?: Maybe<FooterEntity>
}

export type FooterInput = {
  deliveryInfo?: InputMaybe<ComponentFooterFooterDeliveryInfoInput>
  highDigits?: InputMaybe<ComponentFooterFooterHighDigitsInput>
  infoLinks?: InputMaybe<ComponentFooterFooterInfoLinksInput>
  paymentInfo?: InputMaybe<Array<InputMaybe<ComponentFooterFooterPaymentInfoInput>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  socialNetworks?: InputMaybe<ComponentFooterFooterSocialNetworksInput>
}

export type FooterRelationResponseCollection = {
  __typename?: 'FooterRelationResponseCollection'
  data: Array<FooterEntity>
}

export type GenericMorph = ApofinderConfig | ApofinderLandingPage | AppSdk | BepServiceHoursHelp | Clickapo | CommercialBanner | ComponentApofinderAdvertisements | ComponentApofinderButtons | ComponentApofinderFindPharmacyChoice | ComponentApofinderGoogleAd | ComponentApofinderImageAd | ComponentApofinderInfoBlock | ComponentApofinderInputField | ComponentApofinderQureyParameter | ComponentClickapoBlueBanner | ComponentClickapoBottomSheet | ComponentClickapoBottomSheetContent | ComponentClickapoFaq | ComponentClickapoFaqCategory | ComponentClickapoFaqQuestion | ComponentClickapoHomepageSlider | ComponentClickapoHomepageSliderItem | ComponentClickapoLandingScreen | ComponentClickapoLandingScreenHint | ComponentClickapoLimbachCategories | ComponentClickapoLimbachCategoriesSubtopic | ComponentClickapoLimbachCategoriesTopic | ComponentClickapoLimbachFaq | ComponentClickapoLimbachFaqAhd | ComponentClickapoOnboardingSlider | ComponentClickapoOnboardingSliderContentItem | ComponentClickapoPopularTopics | ComponentClickapoPopup | ComponentClickapoPopupSection | ComponentClickapoScanner | ComponentClickapoScannerTip | ComponentClickapoScannerTipList | ComponentClickapoSeasonTopic | ComponentClickapoSeasonalTopics | ComponentClickapoSection | ComponentClickapoSectionContent | ComponentClickapoSupplyPackageFaq | ComponentClickapoTips | ComponentClickapoTipsAnchorItem | ComponentClickapoTipsAnchorList | ComponentClickapoTipsBannerBlock | ComponentClickapoTipsIntro | ComponentClickapoTipsItem | ComponentClickapoTipsListBlock | ComponentClickapoTipsListItem | ComponentClickapoTipsProductsBlock | ComponentCommercialBannersCommercialBannersSelection | ComponentFooterFooterDeliveryInfo | ComponentFooterFooterDeliveryInfoItem | ComponentFooterFooterHighDigits | ComponentFooterFooterInfoLinks | ComponentFooterFooterPaymentInfo | ComponentFooterFooterSocialNetworkItem | ComponentFooterFooterSocialNetworks | ComponentFooterHighDigitItem | ComponentMagazineApofinderConfig | ComponentMagazineApofinderFiltersToHide | ComponentMagazineApofinderOptions | ComponentMagazineApofinderSettings | ComponentMagazineApofinderUtm | ComponentMagazineHomepageDeviceBanner | ComponentMagazineHomepageMagazineBanner | ComponentMagazineSliderBannersCommercial | ComponentMainMenuMainMenuCategory | ComponentMarkenshopMarkenshopSelection | ComponentSdkCardLinkConfiguration | ComponentSdkClient | ComponentSdkForceUpdate | ComponentSdkInfrastructure | ComponentSdkInfrastructureIos | ComponentSdkLegalDocuments | ComponentSdkLegalText | ComponentSdkOnboardingPage | ComponentSdkOnboardingSection | ComponentServicesServiceBannersSelection | ComponentSharedButton1 | ComponentSharedLink | ComponentSharedMetaSocial | ComponentSharedPcase | ComponentSharedSeo | ComponentThemenshopThemenshopSelection | DynamicAccessibility | DynamicDataPrivacy | DynamicImprint | DynamicTermsAndCondition | EmailBanner | Footer | Homepage | I18NLocale | MagazineHomepage | MainMenu | Markenshop | MobileOnboardingScreen | PartnerMapping | Pcase | PharmacyStartpage | Provider | SdkOnboarding | ServiceBanner | Setting | Themenshop | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser

export type Homepage = {
  __typename?: 'Homepage'
  commercialBannersSelection?: Maybe<ComponentCommercialBannersCommercialBannersSelection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  image?: Maybe<UploadFileEntityResponse>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<HomepageRelationResponseCollection>
  markenshopSelection?: Maybe<ComponentMarkenshopMarkenshopSelection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  seo?: Maybe<ComponentSharedSeo>
  serviceBannersSelection?: Maybe<ComponentServicesServiceBannersSelection>
  themenshopSelection?: Maybe<ComponentThemenshopThemenshopSelection>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type HomepageLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>
}

export type HomepageEntity = {
  __typename?: 'HomepageEntity'
  attributes?: Maybe<Homepage>
  id?: Maybe<Scalars['ID']['output']>
}

export type HomepageEntityResponse = {
  __typename?: 'HomepageEntityResponse'
  data?: Maybe<HomepageEntity>
}

export type HomepageInput = {
  commercialBannersSelection?: InputMaybe<ComponentCommercialBannersCommercialBannersSelectionInput>
  image?: InputMaybe<Scalars['ID']['input']>
  markenshopSelection?: InputMaybe<ComponentMarkenshopMarkenshopSelectionInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  seo?: InputMaybe<ComponentSharedSeoInput>
  serviceBannersSelection?: InputMaybe<ComponentServicesServiceBannersSelectionInput>
  themenshopSelection?: InputMaybe<ComponentThemenshopThemenshopSelectionInput>
  title?: InputMaybe<Scalars['String']['input']>
}

export type HomepageRelationResponseCollection = {
  __typename?: 'HomepageRelationResponseCollection'
  data: Array<HomepageEntity>
}

export type I18NLocale = {
  __typename?: 'I18NLocale'
  code?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  name?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity'
  attributes?: Maybe<I18NLocale>
  id?: Maybe<Scalars['ID']['output']>
}

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse'
  data?: Maybe<I18NLocaleEntity>
}

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection'
  data: Array<I18NLocaleEntity>
  meta: ResponseCollectionMeta
}

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>
  code?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<I18NLocaleFiltersInput>
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  contains?: InputMaybe<Scalars['ID']['input']>
  containsi?: InputMaybe<Scalars['ID']['input']>
  endsWith?: InputMaybe<Scalars['ID']['input']>
  eq?: InputMaybe<Scalars['ID']['input']>
  eqi?: InputMaybe<Scalars['ID']['input']>
  gt?: InputMaybe<Scalars['ID']['input']>
  gte?: InputMaybe<Scalars['ID']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  lt?: InputMaybe<Scalars['ID']['input']>
  lte?: InputMaybe<Scalars['ID']['input']>
  ne?: InputMaybe<Scalars['ID']['input']>
  nei?: InputMaybe<Scalars['ID']['input']>
  not?: InputMaybe<IdFilterInput>
  notContains?: InputMaybe<Scalars['ID']['input']>
  notContainsi?: InputMaybe<Scalars['ID']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  startsWith?: InputMaybe<Scalars['ID']['input']>
}

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  contains?: InputMaybe<Scalars['Int']['input']>
  containsi?: InputMaybe<Scalars['Int']['input']>
  endsWith?: InputMaybe<Scalars['Int']['input']>
  eq?: InputMaybe<Scalars['Int']['input']>
  eqi?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  ne?: InputMaybe<Scalars['Int']['input']>
  nei?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<IntFilterInput>
  notContains?: InputMaybe<Scalars['Int']['input']>
  notContainsi?: InputMaybe<Scalars['Int']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  startsWith?: InputMaybe<Scalars['Int']['input']>
}

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  contains?: InputMaybe<Scalars['JSON']['input']>
  containsi?: InputMaybe<Scalars['JSON']['input']>
  endsWith?: InputMaybe<Scalars['JSON']['input']>
  eq?: InputMaybe<Scalars['JSON']['input']>
  eqi?: InputMaybe<Scalars['JSON']['input']>
  gt?: InputMaybe<Scalars['JSON']['input']>
  gte?: InputMaybe<Scalars['JSON']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  lt?: InputMaybe<Scalars['JSON']['input']>
  lte?: InputMaybe<Scalars['JSON']['input']>
  ne?: InputMaybe<Scalars['JSON']['input']>
  nei?: InputMaybe<Scalars['JSON']['input']>
  not?: InputMaybe<JsonFilterInput>
  notContains?: InputMaybe<Scalars['JSON']['input']>
  notContainsi?: InputMaybe<Scalars['JSON']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
  startsWith?: InputMaybe<Scalars['JSON']['input']>
}

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>
  contains?: InputMaybe<Scalars['Long']['input']>
  containsi?: InputMaybe<Scalars['Long']['input']>
  endsWith?: InputMaybe<Scalars['Long']['input']>
  eq?: InputMaybe<Scalars['Long']['input']>
  eqi?: InputMaybe<Scalars['Long']['input']>
  gt?: InputMaybe<Scalars['Long']['input']>
  gte?: InputMaybe<Scalars['Long']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>
  lt?: InputMaybe<Scalars['Long']['input']>
  lte?: InputMaybe<Scalars['Long']['input']>
  ne?: InputMaybe<Scalars['Long']['input']>
  nei?: InputMaybe<Scalars['Long']['input']>
  not?: InputMaybe<LongFilterInput>
  notContains?: InputMaybe<Scalars['Long']['input']>
  notContainsi?: InputMaybe<Scalars['Long']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>
  startsWith?: InputMaybe<Scalars['Long']['input']>
}

export type MagazineHomepage = {
  __typename?: 'MagazineHomepage'
  apofinderConfig?: Maybe<ComponentMagazineApofinderConfig>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  sliderBannersCommercial?: Maybe<ComponentMagazineSliderBannersCommercial>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MagazineHomepageEntity = {
  __typename?: 'MagazineHomepageEntity'
  attributes?: Maybe<MagazineHomepage>
  id?: Maybe<Scalars['ID']['output']>
}

export type MagazineHomepageEntityResponse = {
  __typename?: 'MagazineHomepageEntityResponse'
  data?: Maybe<MagazineHomepageEntity>
}

export type MagazineHomepageInput = {
  apofinderConfig?: InputMaybe<ComponentMagazineApofinderConfigInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  sliderBannersCommercial?: InputMaybe<ComponentMagazineSliderBannersCommercialInput>
}

export type MainMenu = {
  __typename?: 'MainMenu'
  categories?: Maybe<Array<Maybe<ComponentMainMenuMainMenuCategory>>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<MainMenuRelationResponseCollection>
  logo?: Maybe<UploadFileEntityResponse>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MainMenuCategoriesArgs = {
  filters?: InputMaybe<ComponentMainMenuMainMenuCategoryFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type MainMenuLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>
}

export type MainMenuEntity = {
  __typename?: 'MainMenuEntity'
  attributes?: Maybe<MainMenu>
  id?: Maybe<Scalars['ID']['output']>
}

export type MainMenuEntityResponse = {
  __typename?: 'MainMenuEntityResponse'
  data?: Maybe<MainMenuEntity>
}

export type MainMenuInput = {
  categories?: InputMaybe<Array<InputMaybe<ComponentMainMenuMainMenuCategoryInput>>>
  logo?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type MainMenuRelationResponseCollection = {
  __typename?: 'MainMenuRelationResponseCollection'
  data: Array<MainMenuEntity>
}

export type Markenshop = {
  __typename?: 'Markenshop'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  image: UploadFileEntityResponse
  link: Scalars['String']['output']
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<MarkenshopRelationResponseCollection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  sonataMarkenshopId?: Maybe<Scalars['Long']['output']>
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MarkenshopLocalizationsArgs = {
  filters?: InputMaybe<MarkenshopFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type MarkenshopEntity = {
  __typename?: 'MarkenshopEntity'
  attributes?: Maybe<Markenshop>
  id?: Maybe<Scalars['ID']['output']>
}

export type MarkenshopEntityResponse = {
  __typename?: 'MarkenshopEntityResponse'
  data?: Maybe<MarkenshopEntity>
}

export type MarkenshopEntityResponseCollection = {
  __typename?: 'MarkenshopEntityResponseCollection'
  data: Array<MarkenshopEntity>
  meta: ResponseCollectionMeta
}

export type MarkenshopFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MarkenshopFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  link?: InputMaybe<StringFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<MarkenshopFiltersInput>
  not?: InputMaybe<MarkenshopFiltersInput>
  or?: InputMaybe<Array<InputMaybe<MarkenshopFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  sonataMarkenshopId?: InputMaybe<LongFilterInput>
  title?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type MarkenshopInput = {
  image?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  sonataMarkenshopId?: InputMaybe<Scalars['Long']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type MarkenshopRelationResponseCollection = {
  __typename?: 'MarkenshopRelationResponseCollection'
  data: Array<MarkenshopEntity>
}

export type MobileOnboardingScreen = {
  __typename?: 'MobileOnboardingScreen'
  appId: Scalars['String']['output']
  appName?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<MobileOnboardingScreenRelationResponseCollection>
  onboardingScreens?: Maybe<Array<Maybe<ComponentClickapoOnboardingSlider>>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type MobileOnboardingScreenLocalizationsArgs = {
  filters?: InputMaybe<MobileOnboardingScreenFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type MobileOnboardingScreenOnboardingScreensArgs = {
  filters?: InputMaybe<ComponentClickapoOnboardingSliderFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type MobileOnboardingScreenEntity = {
  __typename?: 'MobileOnboardingScreenEntity'
  attributes?: Maybe<MobileOnboardingScreen>
  id?: Maybe<Scalars['ID']['output']>
}

export type MobileOnboardingScreenEntityResponse = {
  __typename?: 'MobileOnboardingScreenEntityResponse'
  data?: Maybe<MobileOnboardingScreenEntity>
}

export type MobileOnboardingScreenEntityResponseCollection = {
  __typename?: 'MobileOnboardingScreenEntityResponseCollection'
  data: Array<MobileOnboardingScreenEntity>
  meta: ResponseCollectionMeta
}

export type MobileOnboardingScreenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MobileOnboardingScreenFiltersInput>>>
  appId?: InputMaybe<StringFilterInput>
  appName?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<MobileOnboardingScreenFiltersInput>
  not?: InputMaybe<MobileOnboardingScreenFiltersInput>
  onboardingScreens?: InputMaybe<ComponentClickapoOnboardingSliderFiltersInput>
  or?: InputMaybe<Array<InputMaybe<MobileOnboardingScreenFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type MobileOnboardingScreenInput = {
  appId?: InputMaybe<Scalars['String']['input']>
  appName?: InputMaybe<Scalars['String']['input']>
  onboardingScreens?: InputMaybe<Array<InputMaybe<ComponentClickapoOnboardingSliderInput>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type MobileOnboardingScreenRelationResponseCollection = {
  __typename?: 'MobileOnboardingScreenRelationResponseCollection'
  data: Array<MobileOnboardingScreenEntity>
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>
  createApofinderConfig?: Maybe<ApofinderConfigEntityResponse>
  createApofinderConfigLocalization?: Maybe<ApofinderConfigEntityResponse>
  createApofinderLandingPageLocalization?: Maybe<ApofinderLandingPageEntityResponse>
  createBepServiceHoursHelp?: Maybe<BepServiceHoursHelpEntityResponse>
  createCommercialBanner?: Maybe<CommercialBannerEntityResponse>
  createCommercialBannerLocalization?: Maybe<CommercialBannerEntityResponse>
  createDynamicAccessibility?: Maybe<DynamicAccessibilityEntityResponse>
  createDynamicAccessibilityLocalization?: Maybe<DynamicAccessibilityEntityResponse>
  createDynamicDataPrivacy?: Maybe<DynamicDataPrivacyEntityResponse>
  createDynamicDataPrivacyLocalization?: Maybe<DynamicDataPrivacyEntityResponse>
  createDynamicImprint?: Maybe<DynamicImprintEntityResponse>
  createDynamicImprintLocalization?: Maybe<DynamicImprintEntityResponse>
  createDynamicTermsAndCondition?: Maybe<DynamicTermsAndConditionEntityResponse>
  createDynamicTermsAndConditionLocalization?: Maybe<DynamicTermsAndConditionEntityResponse>
  createEmailBanner?: Maybe<EmailBannerEntityResponse>
  createFooterLocalization?: Maybe<FooterEntityResponse>
  createHomepageLocalization?: Maybe<HomepageEntityResponse>
  createMainMenuLocalization?: Maybe<MainMenuEntityResponse>
  createMarkenshop?: Maybe<MarkenshopEntityResponse>
  createMarkenshopLocalization?: Maybe<MarkenshopEntityResponse>
  createMobileOnboardingScreen?: Maybe<MobileOnboardingScreenEntityResponse>
  createMobileOnboardingScreenLocalization?: Maybe<MobileOnboardingScreenEntityResponse>
  createPartnerMapping?: Maybe<PartnerMappingEntityResponse>
  createPartnerMappingLocalization?: Maybe<PartnerMappingEntityResponse>
  createPcase?: Maybe<PcaseEntityResponse>
  createPharmacyStartpageLocalization?: Maybe<PharmacyStartpageEntityResponse>
  createProvider?: Maybe<ProviderEntityResponse>
  createSdkOnboarding?: Maybe<SdkOnboardingEntityResponse>
  createServiceBanner?: Maybe<ServiceBannerEntityResponse>
  createServiceBannerLocalization?: Maybe<ServiceBannerEntityResponse>
  createThemenshop?: Maybe<ThemenshopEntityResponse>
  createThemenshopLocalization?: Maybe<ThemenshopEntityResponse>
  createUploadFile?: Maybe<UploadFileEntityResponse>
  createUploadFolder?: Maybe<UploadFolderEntityResponse>
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse
  deleteApofinderConfig?: Maybe<ApofinderConfigEntityResponse>
  deleteApofinderLandingPage?: Maybe<ApofinderLandingPageEntityResponse>
  deleteAppSdk?: Maybe<AppSdkEntityResponse>
  deleteBepServiceHoursHelp?: Maybe<BepServiceHoursHelpEntityResponse>
  deleteClickapo?: Maybe<ClickapoEntityResponse>
  deleteCommercialBanner?: Maybe<CommercialBannerEntityResponse>
  deleteDynamicAccessibility?: Maybe<DynamicAccessibilityEntityResponse>
  deleteDynamicDataPrivacy?: Maybe<DynamicDataPrivacyEntityResponse>
  deleteDynamicImprint?: Maybe<DynamicImprintEntityResponse>
  deleteDynamicTermsAndCondition?: Maybe<DynamicTermsAndConditionEntityResponse>
  deleteEmailBanner?: Maybe<EmailBannerEntityResponse>
  deleteFooter?: Maybe<FooterEntityResponse>
  deleteHomepage?: Maybe<HomepageEntityResponse>
  deleteMagazineHomepage?: Maybe<MagazineHomepageEntityResponse>
  deleteMainMenu?: Maybe<MainMenuEntityResponse>
  deleteMarkenshop?: Maybe<MarkenshopEntityResponse>
  deleteMobileOnboardingScreen?: Maybe<MobileOnboardingScreenEntityResponse>
  deletePartnerMapping?: Maybe<PartnerMappingEntityResponse>
  deletePcase?: Maybe<PcaseEntityResponse>
  deletePharmacyStartpage?: Maybe<PharmacyStartpageEntityResponse>
  deleteProvider?: Maybe<ProviderEntityResponse>
  deleteSdkOnboarding?: Maybe<SdkOnboardingEntityResponse>
  deleteServiceBanner?: Maybe<ServiceBannerEntityResponse>
  deleteSetting?: Maybe<SettingEntityResponse>
  deleteThemenshop?: Maybe<ThemenshopEntityResponse>
  deleteUploadFile?: Maybe<UploadFileEntityResponse>
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>
  login: UsersPermissionsLoginPayload
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>
  /** Register a user */
  register: UsersPermissionsLoginPayload
  removeFile?: Maybe<UploadFileEntityResponse>
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>
  updateApofinderConfig?: Maybe<ApofinderConfigEntityResponse>
  updateApofinderLandingPage?: Maybe<ApofinderLandingPageEntityResponse>
  updateAppSdk?: Maybe<AppSdkEntityResponse>
  updateBepServiceHoursHelp?: Maybe<BepServiceHoursHelpEntityResponse>
  updateClickapo?: Maybe<ClickapoEntityResponse>
  updateCommercialBanner?: Maybe<CommercialBannerEntityResponse>
  updateDynamicAccessibility?: Maybe<DynamicAccessibilityEntityResponse>
  updateDynamicDataPrivacy?: Maybe<DynamicDataPrivacyEntityResponse>
  updateDynamicImprint?: Maybe<DynamicImprintEntityResponse>
  updateDynamicTermsAndCondition?: Maybe<DynamicTermsAndConditionEntityResponse>
  updateEmailBanner?: Maybe<EmailBannerEntityResponse>
  updateFileInfo: UploadFileEntityResponse
  updateFooter?: Maybe<FooterEntityResponse>
  updateHomepage?: Maybe<HomepageEntityResponse>
  updateMagazineHomepage?: Maybe<MagazineHomepageEntityResponse>
  updateMainMenu?: Maybe<MainMenuEntityResponse>
  updateMarkenshop?: Maybe<MarkenshopEntityResponse>
  updateMobileOnboardingScreen?: Maybe<MobileOnboardingScreenEntityResponse>
  updatePartnerMapping?: Maybe<PartnerMappingEntityResponse>
  updatePcase?: Maybe<PcaseEntityResponse>
  updatePharmacyStartpage?: Maybe<PharmacyStartpageEntityResponse>
  updateProvider?: Maybe<ProviderEntityResponse>
  updateSdkOnboarding?: Maybe<SdkOnboardingEntityResponse>
  updateServiceBanner?: Maybe<ServiceBannerEntityResponse>
  updateSetting?: Maybe<SettingEntityResponse>
  updateThemenshop?: Maybe<ThemenshopEntityResponse>
  updateUploadFile?: Maybe<UploadFileEntityResponse>
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse
  upload: UploadFileEntityResponse
}

export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input']
  password: Scalars['String']['input']
  passwordConfirmation: Scalars['String']['input']
}

export type MutationCreateApofinderConfigArgs = {
  data: ApofinderConfigInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateApofinderConfigLocalizationArgs = {
  data?: InputMaybe<ApofinderConfigInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateApofinderLandingPageLocalizationArgs = {
  data?: InputMaybe<ApofinderLandingPageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateBepServiceHoursHelpArgs = {
  data: BepServiceHoursHelpInput
}

export type MutationCreateCommercialBannerArgs = {
  data: CommercialBannerInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateCommercialBannerLocalizationArgs = {
  data?: InputMaybe<CommercialBannerInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateDynamicAccessibilityArgs = {
  data: DynamicAccessibilityInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateDynamicAccessibilityLocalizationArgs = {
  data?: InputMaybe<DynamicAccessibilityInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateDynamicDataPrivacyArgs = {
  data: DynamicDataPrivacyInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateDynamicDataPrivacyLocalizationArgs = {
  data?: InputMaybe<DynamicDataPrivacyInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateDynamicImprintArgs = {
  data: DynamicImprintInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateDynamicImprintLocalizationArgs = {
  data?: InputMaybe<DynamicImprintInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateDynamicTermsAndConditionArgs = {
  data: DynamicTermsAndConditionInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateDynamicTermsAndConditionLocalizationArgs = {
  data?: InputMaybe<DynamicTermsAndConditionInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateEmailBannerArgs = {
  data: EmailBannerInput
}

export type MutationCreateFooterLocalizationArgs = {
  data?: InputMaybe<FooterInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateHomepageLocalizationArgs = {
  data?: InputMaybe<HomepageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateMainMenuLocalizationArgs = {
  data?: InputMaybe<MainMenuInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateMarkenshopArgs = {
  data: MarkenshopInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateMarkenshopLocalizationArgs = {
  data?: InputMaybe<MarkenshopInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateMobileOnboardingScreenArgs = {
  data: MobileOnboardingScreenInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateMobileOnboardingScreenLocalizationArgs = {
  data?: InputMaybe<MobileOnboardingScreenInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreatePartnerMappingArgs = {
  data: PartnerMappingInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreatePartnerMappingLocalizationArgs = {
  data?: InputMaybe<PartnerMappingInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreatePcaseArgs = {
  data: PcaseInput
}

export type MutationCreatePharmacyStartpageLocalizationArgs = {
  data?: InputMaybe<PharmacyStartpageInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateProviderArgs = {
  data: ProviderInput
}

export type MutationCreateSdkOnboardingArgs = {
  data: SdkOnboardingInput
}

export type MutationCreateServiceBannerArgs = {
  data: ServiceBannerInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateServiceBannerLocalizationArgs = {
  data?: InputMaybe<ServiceBannerInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateThemenshopArgs = {
  data: ThemenshopInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateThemenshopLocalizationArgs = {
  data?: InputMaybe<ThemenshopInput>
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationCreateUploadFileArgs = {
  data: UploadFileInput
}

export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput
}

export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput
}

export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput
}

export type MutationDeleteApofinderConfigArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteApofinderLandingPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteBepServiceHoursHelpArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteCommercialBannerArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteDynamicAccessibilityArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteDynamicDataPrivacyArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteDynamicImprintArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteDynamicTermsAndConditionArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteEmailBannerArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteFooterArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteHomepageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteMainMenuArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteMarkenshopArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteMobileOnboardingScreenArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeletePartnerMappingArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeletePcaseArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeletePharmacyStartpageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteProviderArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteSdkOnboardingArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteServiceBannerArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteThemenshopArgs = {
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input']
}

export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input']
}

export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input']
}

export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput
}

export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>
  files: Array<InputMaybe<Scalars['Upload']['input']>>
  ref?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput
}

export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input']
}

export type MutationResetPasswordArgs = {
  code: Scalars['String']['input']
  password: Scalars['String']['input']
  passwordConfirmation: Scalars['String']['input']
}

export type MutationUpdateApofinderConfigArgs = {
  data: ApofinderConfigInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateApofinderLandingPageArgs = {
  data: ApofinderLandingPageInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateAppSdkArgs = {
  data: AppSdkInput
}

export type MutationUpdateBepServiceHoursHelpArgs = {
  data: BepServiceHoursHelpInput
  id: Scalars['ID']['input']
}

export type MutationUpdateClickapoArgs = {
  data: ClickapoInput
}

export type MutationUpdateCommercialBannerArgs = {
  data: CommercialBannerInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateDynamicAccessibilityArgs = {
  data: DynamicAccessibilityInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateDynamicDataPrivacyArgs = {
  data: DynamicDataPrivacyInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateDynamicImprintArgs = {
  data: DynamicImprintInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateDynamicTermsAndConditionArgs = {
  data: DynamicTermsAndConditionInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateEmailBannerArgs = {
  data: EmailBannerInput
  id: Scalars['ID']['input']
}

export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input']
  info?: InputMaybe<FileInfoInput>
}

export type MutationUpdateFooterArgs = {
  data: FooterInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateHomepageArgs = {
  data: HomepageInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateMagazineHomepageArgs = {
  data: MagazineHomepageInput
}

export type MutationUpdateMainMenuArgs = {
  data: MainMenuInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateMarkenshopArgs = {
  data: MarkenshopInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateMobileOnboardingScreenArgs = {
  data: MobileOnboardingScreenInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdatePartnerMappingArgs = {
  data: PartnerMappingInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdatePcaseArgs = {
  data: PcaseInput
  id: Scalars['ID']['input']
}

export type MutationUpdatePharmacyStartpageArgs = {
  data: PharmacyStartpageInput
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateProviderArgs = {
  data: ProviderInput
  id: Scalars['ID']['input']
}

export type MutationUpdateSdkOnboardingArgs = {
  data: SdkOnboardingInput
  id: Scalars['ID']['input']
}

export type MutationUpdateServiceBannerArgs = {
  data: ServiceBannerInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateSettingArgs = {
  data: SettingInput
}

export type MutationUpdateThemenshopArgs = {
  data: ThemenshopInput
  id: Scalars['ID']['input']
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput
  id: Scalars['ID']['input']
}

export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput
  id: Scalars['ID']['input']
}

export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput
  id: Scalars['ID']['input']
}

export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput
  id: Scalars['ID']['input']
}

export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>
  file: Scalars['Upload']['input']
  info?: InputMaybe<FileInfoInput>
  ref?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['ID']['input']>
}

export type Pagination = {
  __typename?: 'Pagination'
  page: Scalars['Int']['output']
  pageCount: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  start?: InputMaybe<Scalars['Int']['input']>
}

export type PartnerMapping = {
  __typename?: 'PartnerMapping'
  accessibilityAppTemplate?: Maybe<DynamicAccessibilityEntityResponse>
  accessibilityTemplate?: Maybe<DynamicAccessibilityEntityResponse>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  dataPrivacyBranchWebTemplate?: Maybe<DynamicDataPrivacyEntityResponse>
  dataPrivacyCheckoutTemplate?: Maybe<DynamicDataPrivacyEntityResponse>
  dataPrivacyTemplate?: Maybe<DynamicDataPrivacyEntityResponse>
  dataPrivacyVendorWebTemplate?: Maybe<DynamicDataPrivacyEntityResponse>
  dataPrivacyWhatsAppTemplate?: Maybe<DynamicDataPrivacyEntityResponse>
  imprintTemplate?: Maybe<DynamicImprintEntityResponse>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<PartnerMappingRelationResponseCollection>
  partnerId: Scalars['String']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  termsCheckoutTemplate?: Maybe<DynamicTermsAndConditionEntityResponse>
  termsTemplate?: Maybe<DynamicTermsAndConditionEntityResponse>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type PartnerMappingLocalizationsArgs = {
  filters?: InputMaybe<PartnerMappingFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type PartnerMappingEntity = {
  __typename?: 'PartnerMappingEntity'
  attributes?: Maybe<PartnerMapping>
  id?: Maybe<Scalars['ID']['output']>
}

export type PartnerMappingEntityResponse = {
  __typename?: 'PartnerMappingEntityResponse'
  data?: Maybe<PartnerMappingEntity>
}

export type PartnerMappingEntityResponseCollection = {
  __typename?: 'PartnerMappingEntityResponseCollection'
  data: Array<PartnerMappingEntity>
  meta: ResponseCollectionMeta
}

export type PartnerMappingFiltersInput = {
  accessibilityAppTemplate?: InputMaybe<DynamicAccessibilityFiltersInput>
  accessibilityTemplate?: InputMaybe<DynamicAccessibilityFiltersInput>
  and?: InputMaybe<Array<InputMaybe<PartnerMappingFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  dataPrivacyBranchWebTemplate?: InputMaybe<DynamicDataPrivacyFiltersInput>
  dataPrivacyCheckoutTemplate?: InputMaybe<DynamicDataPrivacyFiltersInput>
  dataPrivacyTemplate?: InputMaybe<DynamicDataPrivacyFiltersInput>
  dataPrivacyVendorWebTemplate?: InputMaybe<DynamicDataPrivacyFiltersInput>
  dataPrivacyWhatsAppTemplate?: InputMaybe<DynamicDataPrivacyFiltersInput>
  id?: InputMaybe<IdFilterInput>
  imprintTemplate?: InputMaybe<DynamicImprintFiltersInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<PartnerMappingFiltersInput>
  not?: InputMaybe<PartnerMappingFiltersInput>
  or?: InputMaybe<Array<InputMaybe<PartnerMappingFiltersInput>>>
  partnerId?: InputMaybe<StringFilterInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  termsCheckoutTemplate?: InputMaybe<DynamicTermsAndConditionFiltersInput>
  termsTemplate?: InputMaybe<DynamicTermsAndConditionFiltersInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type PartnerMappingInput = {
  accessibilityAppTemplate?: InputMaybe<Scalars['ID']['input']>
  accessibilityTemplate?: InputMaybe<Scalars['ID']['input']>
  dataPrivacyBranchWebTemplate?: InputMaybe<Scalars['ID']['input']>
  dataPrivacyCheckoutTemplate?: InputMaybe<Scalars['ID']['input']>
  dataPrivacyTemplate?: InputMaybe<Scalars['ID']['input']>
  dataPrivacyVendorWebTemplate?: InputMaybe<Scalars['ID']['input']>
  dataPrivacyWhatsAppTemplate?: InputMaybe<Scalars['ID']['input']>
  imprintTemplate?: InputMaybe<Scalars['ID']['input']>
  partnerId?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  termsCheckoutTemplate?: InputMaybe<Scalars['ID']['input']>
  termsTemplate?: InputMaybe<Scalars['ID']['input']>
}

export type PartnerMappingRelationResponseCollection = {
  __typename?: 'PartnerMappingRelationResponseCollection'
  data: Array<PartnerMappingEntity>
}

export type Pcase = {
  __typename?: 'Pcase'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  name: Scalars['String']['output']
  pCaseID: Scalars['Int']['output']
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type PcaseEntity = {
  __typename?: 'PcaseEntity'
  attributes?: Maybe<Pcase>
  id?: Maybe<Scalars['ID']['output']>
}

export type PcaseEntityResponse = {
  __typename?: 'PcaseEntityResponse'
  data?: Maybe<PcaseEntity>
}

export type PcaseEntityResponseCollection = {
  __typename?: 'PcaseEntityResponseCollection'
  data: Array<PcaseEntity>
  meta: ResponseCollectionMeta
}

export type PcaseFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PcaseFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<PcaseFiltersInput>
  or?: InputMaybe<Array<InputMaybe<PcaseFiltersInput>>>
  pCaseID?: InputMaybe<IntFilterInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type PcaseInput = {
  name?: InputMaybe<Scalars['String']['input']>
  pCaseID?: InputMaybe<Scalars['Int']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PcaseRelationResponseCollection = {
  __typename?: 'PcaseRelationResponseCollection'
  data: Array<PcaseEntity>
}

export type PharmacyStartpage = {
  __typename?: 'PharmacyStartpage'
  commercialBannersSelection?: Maybe<ComponentCommercialBannersCommercialBannersSelection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<PharmacyStartpageRelationResponseCollection>
  markenshopSelection?: Maybe<ComponentMarkenshopMarkenshopSelection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  serviceBannersSelection?: Maybe<ComponentServicesServiceBannersSelection>
  themenshopSelection?: Maybe<ComponentThemenshopThemenshopSelection>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type PharmacyStartpageLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>
}

export type PharmacyStartpageEntity = {
  __typename?: 'PharmacyStartpageEntity'
  attributes?: Maybe<PharmacyStartpage>
  id?: Maybe<Scalars['ID']['output']>
}

export type PharmacyStartpageEntityResponse = {
  __typename?: 'PharmacyStartpageEntityResponse'
  data?: Maybe<PharmacyStartpageEntity>
}

export type PharmacyStartpageInput = {
  commercialBannersSelection?: InputMaybe<ComponentCommercialBannersCommercialBannersSelectionInput>
  markenshopSelection?: InputMaybe<ComponentMarkenshopMarkenshopSelectionInput>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  serviceBannersSelection?: InputMaybe<ComponentServicesServiceBannersSelectionInput>
  themenshopSelection?: InputMaybe<ComponentThemenshopThemenshopSelectionInput>
}

export type PharmacyStartpageRelationResponseCollection = {
  __typename?: 'PharmacyStartpageRelationResponseCollection'
  data: Array<PharmacyStartpageEntity>
}

export type Provider = {
  __typename?: 'Provider'
  ProviderId: Scalars['String']['output']
  ProviderName?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ProviderEntity = {
  __typename?: 'ProviderEntity'
  attributes?: Maybe<Provider>
  id?: Maybe<Scalars['ID']['output']>
}

export type ProviderEntityResponse = {
  __typename?: 'ProviderEntityResponse'
  data?: Maybe<ProviderEntity>
}

export type ProviderEntityResponseCollection = {
  __typename?: 'ProviderEntityResponseCollection'
  data: Array<ProviderEntity>
  meta: ResponseCollectionMeta
}

export type ProviderFiltersInput = {
  ProviderId?: InputMaybe<StringFilterInput>
  ProviderName?: InputMaybe<StringFilterInput>
  and?: InputMaybe<Array<InputMaybe<ProviderFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<ProviderFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ProviderFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type ProviderInput = {
  ProviderId?: InputMaybe<Scalars['String']['input']>
  ProviderName?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ProviderRelationResponseCollection = {
  __typename?: 'ProviderRelationResponseCollection'
  data: Array<ProviderEntity>
}

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW',
}

export type Query = {
  __typename?: 'Query'
  apofinderConfig?: Maybe<ApofinderConfigEntityResponse>
  apofinderConfigs?: Maybe<ApofinderConfigEntityResponseCollection>
  apofinderLandingPage?: Maybe<ApofinderLandingPageEntityResponse>
  appSdk?: Maybe<AppSdkEntityResponse>
  bepServiceHoursHelp?: Maybe<BepServiceHoursHelpEntityResponse>
  bepServiceHoursHelps?: Maybe<BepServiceHoursHelpEntityResponseCollection>
  clickapo?: Maybe<ClickapoEntityResponse>
  commercialBanner?: Maybe<CommercialBannerEntityResponse>
  commercialBanners?: Maybe<CommercialBannerEntityResponseCollection>
  dynamicAccessibilities?: Maybe<DynamicAccessibilityEntityResponseCollection>
  dynamicAccessibility?: Maybe<DynamicAccessibilityEntityResponse>
  dynamicDataPrivacies?: Maybe<DynamicDataPrivacyEntityResponseCollection>
  dynamicDataPrivacy?: Maybe<DynamicDataPrivacyEntityResponse>
  dynamicImprint?: Maybe<DynamicImprintEntityResponse>
  dynamicImprints?: Maybe<DynamicImprintEntityResponseCollection>
  dynamicTermsAndCondition?: Maybe<DynamicTermsAndConditionEntityResponse>
  dynamicTermsAndConditions?: Maybe<DynamicTermsAndConditionEntityResponseCollection>
  emailBanner?: Maybe<EmailBannerEntityResponse>
  emailBanners?: Maybe<EmailBannerEntityResponseCollection>
  footer?: Maybe<FooterEntityResponse>
  homepage?: Maybe<HomepageEntityResponse>
  i18NLocale?: Maybe<I18NLocaleEntityResponse>
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>
  magazineHomepage?: Maybe<MagazineHomepageEntityResponse>
  mainMenu?: Maybe<MainMenuEntityResponse>
  markenshop?: Maybe<MarkenshopEntityResponse>
  markenshops?: Maybe<MarkenshopEntityResponseCollection>
  me?: Maybe<UsersPermissionsMe>
  mobileOnboardingScreen?: Maybe<MobileOnboardingScreenEntityResponse>
  mobileOnboardingScreens?: Maybe<MobileOnboardingScreenEntityResponseCollection>
  partnerMapping?: Maybe<PartnerMappingEntityResponse>
  partnerMappings?: Maybe<PartnerMappingEntityResponseCollection>
  pcase?: Maybe<PcaseEntityResponse>
  pcases?: Maybe<PcaseEntityResponseCollection>
  pharmacyStartpage?: Maybe<PharmacyStartpageEntityResponse>
  provider?: Maybe<ProviderEntityResponse>
  providers?: Maybe<ProviderEntityResponseCollection>
  sdkOnboarding?: Maybe<SdkOnboardingEntityResponse>
  sdkOnboardings?: Maybe<SdkOnboardingEntityResponseCollection>
  serviceBanner?: Maybe<ServiceBannerEntityResponse>
  serviceBanners?: Maybe<ServiceBannerEntityResponseCollection>
  setting?: Maybe<SettingEntityResponse>
  themenshop?: Maybe<ThemenshopEntityResponse>
  themenshops?: Maybe<ThemenshopEntityResponseCollection>
  uploadFile?: Maybe<UploadFileEntityResponse>
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>
  uploadFolder?: Maybe<UploadFolderEntityResponse>
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>
}

export type QueryApofinderConfigArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryApofinderConfigsArgs = {
  filters?: InputMaybe<ApofinderConfigFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryApofinderLandingPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  publicationState?: InputMaybe<PublicationState>
}

export type QueryAppSdkArgs = {
  publicationState?: InputMaybe<PublicationState>
}

export type QueryBepServiceHoursHelpArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryBepServiceHoursHelpsArgs = {
  filters?: InputMaybe<BepServiceHoursHelpFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryClickapoArgs = {
  publicationState?: InputMaybe<PublicationState>
}

export type QueryCommercialBannerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryCommercialBannersArgs = {
  filters?: InputMaybe<CommercialBannerFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryDynamicAccessibilitiesArgs = {
  filters?: InputMaybe<DynamicAccessibilityFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryDynamicAccessibilityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryDynamicDataPrivaciesArgs = {
  filters?: InputMaybe<DynamicDataPrivacyFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryDynamicDataPrivacyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryDynamicImprintArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryDynamicImprintsArgs = {
  filters?: InputMaybe<DynamicImprintFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryDynamicTermsAndConditionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryDynamicTermsAndConditionsArgs = {
  filters?: InputMaybe<DynamicTermsAndConditionFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryEmailBannerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryEmailBannersArgs = {
  filters?: InputMaybe<EmailBannerFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryFooterArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  publicationState?: InputMaybe<PublicationState>
}

export type QueryHomepageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  publicationState?: InputMaybe<PublicationState>
}

export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryMagazineHomepageArgs = {
  publicationState?: InputMaybe<PublicationState>
}

export type QueryMainMenuArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  publicationState?: InputMaybe<PublicationState>
}

export type QueryMarkenshopArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryMarkenshopsArgs = {
  filters?: InputMaybe<MarkenshopFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryMobileOnboardingScreenArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryMobileOnboardingScreensArgs = {
  filters?: InputMaybe<MobileOnboardingScreenFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryPartnerMappingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryPartnerMappingsArgs = {
  filters?: InputMaybe<PartnerMappingFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryPcaseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPcasesArgs = {
  filters?: InputMaybe<PcaseFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryPharmacyStartpageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  publicationState?: InputMaybe<PublicationState>
}

export type QueryProviderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryProvidersArgs = {
  filters?: InputMaybe<ProviderFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QuerySdkOnboardingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QuerySdkOnboardingsArgs = {
  filters?: InputMaybe<SdkOnboardingFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryServiceBannerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryServiceBannersArgs = {
  filters?: InputMaybe<ServiceBannerFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QuerySettingArgs = {
  publicationState?: InputMaybe<PublicationState>
}

export type QueryThemenshopArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
}

export type QueryThemenshopsArgs = {
  filters?: InputMaybe<ThemenshopFiltersInput>
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta'
  pagination: Pagination
}

export type SdkOnboarding = {
  __typename?: 'SdkOnboarding'
  clientId: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  page?: Maybe<Array<Maybe<ComponentSdkOnboardingPage>>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SdkOnboardingPageArgs = {
  filters?: InputMaybe<ComponentSdkOnboardingPageFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type SdkOnboardingEntity = {
  __typename?: 'SdkOnboardingEntity'
  attributes?: Maybe<SdkOnboarding>
  id?: Maybe<Scalars['ID']['output']>
}

export type SdkOnboardingEntityResponse = {
  __typename?: 'SdkOnboardingEntityResponse'
  data?: Maybe<SdkOnboardingEntity>
}

export type SdkOnboardingEntityResponseCollection = {
  __typename?: 'SdkOnboardingEntityResponseCollection'
  data: Array<SdkOnboardingEntity>
  meta: ResponseCollectionMeta
}

export type SdkOnboardingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SdkOnboardingFiltersInput>>>
  clientId?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<SdkOnboardingFiltersInput>
  or?: InputMaybe<Array<InputMaybe<SdkOnboardingFiltersInput>>>
  page?: InputMaybe<ComponentSdkOnboardingPageFiltersInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type SdkOnboardingInput = {
  clientId?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Array<InputMaybe<ComponentSdkOnboardingPageInput>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ServiceBanner = {
  __typename?: 'ServiceBanner'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  desktopImage: UploadFileEntityResponse
  link: Scalars['String']['output']
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<ServiceBannerRelationResponseCollection>
  mobileImage: UploadFileEntityResponse
  name: Scalars['String']['output']
  openNewWindow?: Maybe<Scalars['Boolean']['output']>
  pcase?: Maybe<Array<Maybe<ComponentSharedPcase>>>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ServiceBannerLocalizationsArgs = {
  filters?: InputMaybe<ServiceBannerFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ServiceBannerPcaseArgs = {
  filters?: InputMaybe<ComponentSharedPcaseFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ServiceBannerEntity = {
  __typename?: 'ServiceBannerEntity'
  attributes?: Maybe<ServiceBanner>
  id?: Maybe<Scalars['ID']['output']>
}

export type ServiceBannerEntityResponse = {
  __typename?: 'ServiceBannerEntityResponse'
  data?: Maybe<ServiceBannerEntity>
}

export type ServiceBannerEntityResponseCollection = {
  __typename?: 'ServiceBannerEntityResponseCollection'
  data: Array<ServiceBannerEntity>
  meta: ResponseCollectionMeta
}

export type ServiceBannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ServiceBannerFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  link?: InputMaybe<StringFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<ServiceBannerFiltersInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<ServiceBannerFiltersInput>
  openNewWindow?: InputMaybe<BooleanFilterInput>
  or?: InputMaybe<Array<InputMaybe<ServiceBannerFiltersInput>>>
  pcase?: InputMaybe<ComponentSharedPcaseFiltersInput>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type ServiceBannerInput = {
  desktopImage?: InputMaybe<Scalars['ID']['input']>
  link?: InputMaybe<Scalars['String']['input']>
  mobileImage?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  openNewWindow?: InputMaybe<Scalars['Boolean']['input']>
  pcase?: InputMaybe<Array<InputMaybe<ComponentSharedPcaseInput>>>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type ServiceBannerRelationResponseCollection = {
  __typename?: 'ServiceBannerRelationResponseCollection'
  data: Array<ServiceBannerEntity>
}

export type Setting = {
  __typename?: 'Setting'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  showLogs?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type SettingEntity = {
  __typename?: 'SettingEntity'
  attributes?: Maybe<Setting>
  id?: Maybe<Scalars['ID']['output']>
}

export type SettingEntityResponse = {
  __typename?: 'SettingEntityResponse'
  data?: Maybe<SettingEntity>
}

export type SettingInput = {
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  showLogs?: InputMaybe<Scalars['Boolean']['input']>
}

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  contains?: InputMaybe<Scalars['String']['input']>
  containsi?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  eq?: InputMaybe<Scalars['String']['input']>
  eqi?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  ne?: InputMaybe<Scalars['String']['input']>
  nei?: InputMaybe<Scalars['String']['input']>
  not?: InputMaybe<StringFilterInput>
  notContains?: InputMaybe<Scalars['String']['input']>
  notContainsi?: InputMaybe<Scalars['String']['input']>
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  notNull?: InputMaybe<Scalars['Boolean']['input']>
  null?: InputMaybe<Scalars['Boolean']['input']>
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type Themenshop = {
  __typename?: 'Themenshop'
  button1?: Maybe<ComponentSharedButton1>
  button2?: Maybe<ComponentSharedButton1>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  excerpt?: Maybe<Scalars['String']['output']>
  image: UploadFileEntityResponse
  locale?: Maybe<Scalars['String']['output']>
  localizations?: Maybe<ThemenshopRelationResponseCollection>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  sonataThemenshopId?: Maybe<Scalars['Long']['output']>
  title: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ThemenshopLocalizationsArgs = {
  filters?: InputMaybe<ThemenshopFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  publicationState?: InputMaybe<PublicationState>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type ThemenshopEntity = {
  __typename?: 'ThemenshopEntity'
  attributes?: Maybe<Themenshop>
  id?: Maybe<Scalars['ID']['output']>
}

export type ThemenshopEntityResponse = {
  __typename?: 'ThemenshopEntityResponse'
  data?: Maybe<ThemenshopEntity>
}

export type ThemenshopEntityResponseCollection = {
  __typename?: 'ThemenshopEntityResponseCollection'
  data: Array<ThemenshopEntity>
  meta: ResponseCollectionMeta
}

export type ThemenshopFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ThemenshopFiltersInput>>>
  button1?: InputMaybe<ComponentSharedButton1FiltersInput>
  button2?: InputMaybe<ComponentSharedButton1FiltersInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  excerpt?: InputMaybe<StringFilterInput>
  id?: InputMaybe<IdFilterInput>
  locale?: InputMaybe<StringFilterInput>
  localizations?: InputMaybe<ThemenshopFiltersInput>
  not?: InputMaybe<ThemenshopFiltersInput>
  or?: InputMaybe<Array<InputMaybe<ThemenshopFiltersInput>>>
  publishedAt?: InputMaybe<DateTimeFilterInput>
  sonataThemenshopId?: InputMaybe<LongFilterInput>
  title?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type ThemenshopInput = {
  button1?: InputMaybe<ComponentSharedButton1Input>
  button2?: InputMaybe<ComponentSharedButton1Input>
  excerpt?: InputMaybe<Scalars['String']['input']>
  image?: InputMaybe<Scalars['ID']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  sonataThemenshopId?: InputMaybe<Scalars['Long']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ThemenshopRelationResponseCollection = {
  __typename?: 'ThemenshopRelationResponseCollection'
  data: Array<ThemenshopEntity>
}

export type UploadFile = {
  __typename?: 'UploadFile'
  alternativeText?: Maybe<Scalars['String']['output']>
  caption?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  ext?: Maybe<Scalars['String']['output']>
  formats?: Maybe<Scalars['JSON']['output']>
  hash: Scalars['String']['output']
  height?: Maybe<Scalars['Int']['output']>
  mime: Scalars['String']['output']
  name: Scalars['String']['output']
  previewUrl?: Maybe<Scalars['String']['output']>
  provider: Scalars['String']['output']
  provider_metadata?: Maybe<Scalars['JSON']['output']>
  related?: Maybe<Array<Maybe<GenericMorph>>>
  size: Scalars['Float']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  url: Scalars['String']['output']
  width?: Maybe<Scalars['Int']['output']>
}

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity'
  attributes?: Maybe<UploadFile>
  id?: Maybe<Scalars['ID']['output']>
}

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse'
  data?: Maybe<UploadFileEntity>
}

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection'
  data: Array<UploadFileEntity>
  meta: ResponseCollectionMeta
}

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>
  caption?: InputMaybe<StringFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  ext?: InputMaybe<StringFilterInput>
  folder?: InputMaybe<UploadFolderFiltersInput>
  folderPath?: InputMaybe<StringFilterInput>
  formats?: InputMaybe<JsonFilterInput>
  hash?: InputMaybe<StringFilterInput>
  height?: InputMaybe<IntFilterInput>
  id?: InputMaybe<IdFilterInput>
  mime?: InputMaybe<StringFilterInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<UploadFileFiltersInput>
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>
  previewUrl?: InputMaybe<StringFilterInput>
  provider?: InputMaybe<StringFilterInput>
  provider_metadata?: InputMaybe<JsonFilterInput>
  size?: InputMaybe<FloatFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  url?: InputMaybe<StringFilterInput>
  width?: InputMaybe<IntFilterInput>
}

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>
  caption?: InputMaybe<Scalars['String']['input']>
  ext?: InputMaybe<Scalars['String']['input']>
  folder?: InputMaybe<Scalars['ID']['input']>
  folderPath?: InputMaybe<Scalars['String']['input']>
  formats?: InputMaybe<Scalars['JSON']['input']>
  hash?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Int']['input']>
  mime?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  previewUrl?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>
  size?: InputMaybe<Scalars['Float']['input']>
  url?: InputMaybe<Scalars['String']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection'
  data: Array<UploadFileEntity>
}

export type UploadFolder = {
  __typename?: 'UploadFolder'
  children?: Maybe<UploadFolderRelationResponseCollection>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  files?: Maybe<UploadFileRelationResponseCollection>
  name: Scalars['String']['output']
  parent?: Maybe<UploadFolderEntityResponse>
  path: Scalars['String']['output']
  pathId: Scalars['Int']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity'
  attributes?: Maybe<UploadFolder>
  id?: Maybe<Scalars['ID']['output']>
}

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse'
  data?: Maybe<UploadFolderEntity>
}

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection'
  data: Array<UploadFolderEntity>
  meta: ResponseCollectionMeta
}

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>
  children?: InputMaybe<UploadFolderFiltersInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  files?: InputMaybe<UploadFileFiltersInput>
  id?: InputMaybe<IdFilterInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<UploadFolderFiltersInput>
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>
  parent?: InputMaybe<UploadFolderFiltersInput>
  path?: InputMaybe<StringFilterInput>
  pathId?: InputMaybe<IntFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  name?: InputMaybe<Scalars['String']['input']>
  parent?: InputMaybe<Scalars['ID']['input']>
  path?: InputMaybe<Scalars['String']['input']>
  pathId?: InputMaybe<Scalars['Int']['input']>
}

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection'
  data: Array<UploadFolderEntity>
}

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload'
  ok: Scalars['Boolean']['output']
}

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload'
  ok: Scalars['Boolean']['output']
}

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input']
  password: Scalars['String']['input']
  provider?: Scalars['String']['input']
}

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload'
  jwt?: Maybe<Scalars['String']['output']>
  user: UsersPermissionsMe
}

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe'
  blocked?: Maybe<Scalars['Boolean']['output']>
  confirmed?: Maybe<Scalars['Boolean']['output']>
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  role?: Maybe<UsersPermissionsMeRole>
  username: Scalars['String']['output']
}

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type?: Maybe<Scalars['String']['output']>
}

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload'
  ok: Scalars['Boolean']['output']
}

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission'
  action: Scalars['String']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  role?: Maybe<UsersPermissionsRoleEntityResponse>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity'
  attributes?: Maybe<UsersPermissionsPermission>
  id?: Maybe<Scalars['ID']['output']>
}

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
}

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection'
  data: Array<UsersPermissionsPermissionEntity>
}

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
  username: Scalars['String']['input']
}

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>
}

export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>
  pagination?: InputMaybe<PaginationArg>
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
}

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity'
  attributes?: Maybe<UsersPermissionsRole>
  id?: Maybe<Scalars['ID']['output']>
}

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse'
  data?: Maybe<UsersPermissionsRoleEntity>
}

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection'
  data: Array<UsersPermissionsRoleEntity>
  meta: ResponseCollectionMeta
}

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>
  createdAt?: InputMaybe<DateTimeFilterInput>
  description?: InputMaybe<StringFilterInput>
  id?: InputMaybe<IdFilterInput>
  name?: InputMaybe<StringFilterInput>
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>
  type?: InputMaybe<StringFilterInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  users?: InputMaybe<UsersPermissionsUserFiltersInput>
}

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
  type?: InputMaybe<Scalars['String']['input']>
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload'
  ok: Scalars['Boolean']['output']
}

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser'
  blocked?: Maybe<Scalars['Boolean']['output']>
  confirmed?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  email: Scalars['String']['output']
  provider?: Maybe<Scalars['String']['output']>
  role?: Maybe<UsersPermissionsRoleEntityResponse>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  username: Scalars['String']['output']
}

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity'
  attributes?: Maybe<UsersPermissionsUser>
  id?: Maybe<Scalars['ID']['output']>
}

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse'
  data?: Maybe<UsersPermissionsUserEntity>
}

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection'
  data: Array<UsersPermissionsUserEntity>
  meta: ResponseCollectionMeta
}

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>
  blocked?: InputMaybe<BooleanFilterInput>
  confirmationToken?: InputMaybe<StringFilterInput>
  confirmed?: InputMaybe<BooleanFilterInput>
  createdAt?: InputMaybe<DateTimeFilterInput>
  email?: InputMaybe<StringFilterInput>
  id?: InputMaybe<IdFilterInput>
  not?: InputMaybe<UsersPermissionsUserFiltersInput>
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>
  password?: InputMaybe<StringFilterInput>
  provider?: InputMaybe<StringFilterInput>
  resetPasswordToken?: InputMaybe<StringFilterInput>
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>
  updatedAt?: InputMaybe<DateTimeFilterInput>
  username?: InputMaybe<StringFilterInput>
}

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>
  confirmationToken?: InputMaybe<Scalars['String']['input']>
  confirmed?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['ID']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection'
  data: Array<UsersPermissionsUserEntity>
}

export type GetApofinderConfigQueryVariables = Exact<{
  cnf?: InputMaybe<Scalars['String']['input']>
}>

export type GetApofinderConfigQuery = { __typename?: 'Query'; apofinderConfigs?: { __typename?: 'ApofinderConfigEntityResponseCollection'; data: Array<{ __typename?: 'ApofinderConfigEntity'; attributes?: { __typename?: 'ApofinderConfig'; title?: string | null; subtitle?: string | null; cnf: string; queryParameters?: Array<{ __typename?: 'ComponentApofinderQureyParameter'; param?: string | null } | null> | null; findPharmacyChoice?: { __typename?: 'ComponentApofinderFindPharmacyChoice'; display?: Enum_Componentapofinderfindpharmacychoice_Display | null; buttons?: { __typename?: 'ComponentApofinderButtons'; findPharmacyButtonLabel?: string | null; scanPharmacyButtonLabel?: string | null; displayScanButton?: boolean | null } | null; inputField?: { __typename?: 'ComponentApofinderInputField'; value?: string | null; placeholder?: string | null } | null } | null; infoBlock?: { __typename?: 'ComponentApofinderInfoBlock'; text?: string | null; imagePosition?: Enum_Componentapofinderinfoblock_Imageposition | null; pzn?: string | null; image?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } | null } | null; ads?: Array<{ __typename?: 'ComponentApofinderGoogleAd'; headScript?: string | null; bodyScript?: string | null } | { __typename?: 'ComponentApofinderImageAd'; link?: string | null; newWindow?: boolean | null; imageDesktop?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } | null; imageMobile?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } | null } | { __typename?: 'Error' } | null> | null } | null }> } | null }

export type GetApofinderLandingPageQueryVariables = Exact<{ [key: string]: never }>

export type GetApofinderLandingPageQuery = { __typename?: 'Query'; apofinderLandingPage?: { __typename?: 'ApofinderLandingPageEntityResponse'; data?: { __typename?: 'ApofinderLandingPageEntity'; attributes?: { __typename?: 'ApofinderLandingPage'; title?: string | null; subtitle?: string | null; findPharmacyChoice?: { __typename?: 'ComponentApofinderFindPharmacyChoice'; display?: Enum_Componentapofinderfindpharmacychoice_Display | null; buttons?: { __typename?: 'ComponentApofinderButtons'; findPharmacyButtonLabel?: string | null; scanPharmacyButtonLabel?: string | null; displayScanButton?: boolean | null } | null; inputField?: { __typename?: 'ComponentApofinderInputField'; value?: string | null; placeholder?: string | null } | null } | null; queryParameters?: Array<{ __typename?: 'ComponentApofinderQureyParameter'; param?: string | null } | null> | null; infoBlock?: { __typename?: 'ComponentApofinderInfoBlock'; text?: string | null; imagePosition?: Enum_Componentapofinderinfoblock_Imageposition | null; pzn?: string | null; image?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } | null } | null; ads?: Array<{ __typename?: 'ComponentApofinderGoogleAd'; id: string; headScript?: string | null; bodyScript?: string | null } | { __typename?: 'ComponentApofinderImageAd'; id: string; link?: string | null; newWindow?: boolean | null; imageDesktop?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } | null; imageMobile?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } | null } | { __typename?: 'Error' } | null> | null } | null } | null } | null }

export type GetEpaperApofinderConfigQueryVariables = Exact<{ [key: string]: never }>

export type GetEpaperApofinderConfigQuery = { __typename?: 'Query'; magazineHomepage?: { __typename?: 'MagazineHomepageEntityResponse'; data?: { __typename?: 'MagazineHomepageEntity'; attributes?: { __typename?: 'MagazineHomepage'; apofinderConfig?: { __typename?: 'ComponentMagazineApofinderConfig'; options?: { __typename?: 'ComponentMagazineApofinderOptions'; couponCode?: string | null; headline?: string | null; text?: string | null; view?: string | null; openLinksInNewWindow?: boolean | null; hideMagazines?: boolean | null; pharmaciesPerPage?: string | null; query?: string | null; lat?: string | null; lng?: string | null; geolocation?: boolean | null; open?: boolean | null; delivery?: boolean | null; expressDelivery?: boolean | null; magazines?: string | null; pzn?: string | null; test?: boolean | null; pcase?: string | null; products?: string | null; productCategory?: string | null; wirkstoffe?: string | null; showAllPharmacies?: boolean | null; showAllPharmaciesFilter?: boolean | null; needsGoogleConsent?: boolean | null; consentActive?: boolean | null; activateAllPharmaciesFilter?: boolean | null; manufacturer?: string | null; destination?: string | null; customUrl?: string | null; recommendedProducts?: string | null; showRequestButton?: boolean | null } | null; filtersToHide?: { __typename?: 'ComponentMagazineApofinderFiltersToHide'; openPharmacies?: boolean | null; delivery?: boolean | null; expressDelivery?: boolean | null; magazines?: boolean | null } | null; utm?: { __typename?: 'ComponentMagazineApofinderUtm'; source?: string | null; medium?: string | null; campaign?: string | null; term?: string | null; content?: string | null } | null; settings?: { __typename?: 'ComponentMagazineApofinderSettings'; locationMarkerIcon?: string | null; pharmacyMarkerIcon?: string | null; primaryFont?: string | null; primaryFontFamily?: string | null; primaryColor?: string | null; secondaryColor?: string | null; pharmacyOpenColor?: string | null; pharmacyClosedColor?: string | null; searchButtonColor?: string | null; pharmacyButtonColor?: string | null; filterButtonsRadius?: string | null; pharmacyButtonRadius?: string | null } | null } | null } | null } | null } | null }

export type GetMagazineHomepageQueryVariables = Exact<{ [key: string]: never }>

export type GetMagazineHomepageQuery = { __typename?: 'Query'; magazineHomepage?: { __typename?: 'MagazineHomepageEntityResponse'; data?: { __typename?: 'MagazineHomepageEntity'; attributes?: { __typename?: 'MagazineHomepage'; sliderBannersCommercial?: { __typename?: 'ComponentMagazineSliderBannersCommercial'; mobile?: Array<{ __typename?: 'ComponentMagazineHomepageDeviceBanner'; href?: string | null; image?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string; hash: string } | null } | null } | null } | null> | null; desktop?: Array<{ __typename?: 'ComponentMagazineHomepageDeviceBanner'; href?: string | null; image?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string; hash: string } | null } | null } | null } | null> | null } | null } | null } | null } | null }

export type GetHeaderAndFooterQueryVariables = Exact<{ [key: string]: never }>

export type GetHeaderAndFooterQuery = { __typename?: 'Query'; footer?: { __typename?: 'FooterEntityResponse'; data?: { __typename?: 'FooterEntity'; attributes?: { __typename?: 'Footer'; paymentInfo?: Array<{ __typename?: 'ComponentFooterFooterPaymentInfo'; title?: string | null; description?: string | null; whenToDisplay: Enum_Componentfooterfooterpaymentinfo_Whentodisplay; image?: { __typename?: 'UploadFileRelationResponseCollection'; data: Array<{ __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null }> } | null } | null> | null; deliveryInfo?: { __typename?: 'ComponentFooterFooterDeliveryInfo'; title?: string | null; deliveryItem?: Array<{ __typename?: 'ComponentFooterFooterDeliveryInfoItem'; title?: string | null; description?: string | null; whenToDisplay: Enum_Componentfooterfooterdeliveryinfoitem_Whentodisplay } | null> | null } | null; infoLinks?: { __typename?: 'ComponentFooterFooterInfoLinks'; title?: string | null; link?: Array<{ __typename?: 'ComponentSharedLink'; text?: string | null; url?: string | null; newTab?: boolean | null; elementId?: string | null } | null> | null } | null; socialNetworks?: { __typename?: 'ComponentFooterFooterSocialNetworks'; title?: string | null; socialNetworkItem?: Array<{ __typename?: 'ComponentFooterFooterSocialNetworkItem'; network?: Enum_Componentfooterfootersocialnetworkitem_Network | null; url?: string | null } | null> | null } | null } | null } | null } | null; mainMenu?: { __typename?: 'MainMenuEntityResponse'; data?: { __typename?: 'MainMenuEntity'; attributes?: { __typename?: 'MainMenu'; logo?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } | null; categories?: Array<{ __typename?: 'ComponentMainMenuMainMenuCategory'; title?: string | null; link?: Array<{ __typename?: 'ComponentSharedLink'; text?: string | null; url?: string | null; authDisplay?: Enum_Componentsharedlink_Authdisplay | null; newTab?: boolean | null; elementId?: string | null } | null> | null } | null> | null } | null } | null } | null }

export type GetHomepageQueryVariables = Exact<{ [key: string]: never }>

export type GetHomepageQuery = { __typename?: 'Query'; homepage?: { __typename?: 'HomepageEntityResponse'; data?: { __typename?: 'HomepageEntity'; attributes?: { __typename?: 'Homepage'; title?: string | null; image?: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } | null; themenshopSelection?: { __typename?: 'ComponentThemenshopThemenshopSelection'; title: string; displayAll?: number | null; useCustomDisplay?: boolean | null; button: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null }; customDisplay?: { __typename?: 'ThemenshopRelationResponseCollection'; data: Array<{ __typename?: 'ThemenshopEntity'; id?: string | null; attributes?: { __typename?: 'Themenshop'; sonataThemenshopId?: any | null; title: string; excerpt?: string | null; image: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; button1?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null; button2?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null } | null }> } | null } | null; markenshopSelection?: { __typename?: 'ComponentMarkenshopMarkenshopSelection'; title: string; displayAll?: number | null; useCustomDisplay?: boolean | null; button?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null; customDisplay?: { __typename?: 'MarkenshopRelationResponseCollection'; data: Array<{ __typename?: 'MarkenshopEntity'; id?: string | null; attributes?: { __typename?: 'Markenshop'; sonataMarkenshopId?: any | null; title: string; link: string; image: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } } | null }> } | null } | null; serviceBannersSelection?: { __typename?: 'ComponentServicesServiceBannersSelection'; displayAll?: number | null; useCustomDisplay?: boolean | null; customDisplay?: { __typename?: 'ServiceBannerRelationResponseCollection'; data: Array<{ __typename?: 'ServiceBannerEntity'; id?: string | null; attributes?: { __typename?: 'ServiceBanner'; name: string; link: string; openNewWindow?: boolean | null; desktopImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; mobileImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; pcase?: Array<{ __typename?: 'ComponentSharedPcase'; pcase: string } | null> | null } | null }> } | null } | null; commercialBannersSelection?: { __typename?: 'ComponentCommercialBannersCommercialBannersSelection'; displayAll?: number | null; useCustomDisplay?: boolean | null; customDisplay?: { __typename?: 'CommercialBannerRelationResponseCollection'; data: Array<{ __typename?: 'CommercialBannerEntity'; id?: string | null; attributes?: { __typename?: 'CommercialBanner'; name: string; link: string; openNewWindow?: boolean | null; desktopImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; mobileImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; pcase?: Array<{ __typename?: 'ComponentSharedPcase'; pcase: string } | null> | null } | null }> } | null } | null } | null } | null } | null; markenshops?: { __typename?: 'MarkenshopEntityResponseCollection'; data: Array<{ __typename?: 'MarkenshopEntity'; id?: string | null; attributes?: { __typename?: 'Markenshop'; sonataMarkenshopId?: any | null; title: string; link: string; image: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } } | null }> } | null; themenshops?: { __typename?: 'ThemenshopEntityResponseCollection'; data: Array<{ __typename?: 'ThemenshopEntity'; id?: string | null; attributes?: { __typename?: 'Themenshop'; sonataThemenshopId?: any | null; title: string; excerpt?: string | null; image: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; button1?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null; button2?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null } | null }> } | null; commercialBanners?: { __typename?: 'CommercialBannerEntityResponseCollection'; data: Array<{ __typename?: 'CommercialBannerEntity'; id?: string | null; attributes?: { __typename?: 'CommercialBanner'; name: string; link: string; openNewWindow?: boolean | null; desktopImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; mobileImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; pcase?: Array<{ __typename?: 'ComponentSharedPcase'; pcase: string } | null> | null } | null }> } | null; serviceBanners?: { __typename?: 'ServiceBannerEntityResponseCollection'; data: Array<{ __typename?: 'ServiceBannerEntity'; id?: string | null; attributes?: { __typename?: 'ServiceBanner'; name: string; link: string; openNewWindow?: boolean | null; desktopImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; mobileImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; pcase?: Array<{ __typename?: 'ComponentSharedPcase'; pcase: string } | null> | null } | null }> } | null }

export type GetPharmacyStartpageQueryVariables = Exact<{ [key: string]: never }>

export type GetPharmacyStartpageQuery = { __typename?: 'Query'; pharmacyStartpage?: { __typename?: 'PharmacyStartpageEntityResponse'; data?: { __typename?: 'PharmacyStartpageEntity'; attributes?: { __typename?: 'PharmacyStartpage'; themenshopSelection?: { __typename?: 'ComponentThemenshopThemenshopSelection'; title: string; displayAll?: number | null; useCustomDisplay?: boolean | null; button: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null }; customDisplay?: { __typename?: 'ThemenshopRelationResponseCollection'; data: Array<{ __typename?: 'ThemenshopEntity'; id?: string | null; attributes?: { __typename?: 'Themenshop'; sonataThemenshopId?: any | null; title: string; excerpt?: string | null; image: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; button1?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null; button2?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null } | null }> } | null } | null; markenshopSelection?: { __typename?: 'ComponentMarkenshopMarkenshopSelection'; title: string; displayAll?: number | null; useCustomDisplay?: boolean | null; button?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null; customDisplay?: { __typename?: 'MarkenshopRelationResponseCollection'; data: Array<{ __typename?: 'MarkenshopEntity'; id?: string | null; attributes?: { __typename?: 'Markenshop'; sonataMarkenshopId?: any | null; title: string; link: string; image: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } } | null }> } | null } | null; serviceBannersSelection?: { __typename?: 'ComponentServicesServiceBannersSelection'; displayAll?: number | null; useCustomDisplay?: boolean | null; customDisplay?: { __typename?: 'ServiceBannerRelationResponseCollection'; data: Array<{ __typename?: 'ServiceBannerEntity'; id?: string | null; attributes?: { __typename?: 'ServiceBanner'; name: string; link: string; openNewWindow?: boolean | null; desktopImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; mobileImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; pcase?: Array<{ __typename?: 'ComponentSharedPcase'; pcase: string } | null> | null } | null }> } | null } | null; commercialBannersSelection?: { __typename?: 'ComponentCommercialBannersCommercialBannersSelection'; displayAll?: number | null; useCustomDisplay?: boolean | null; customDisplay?: { __typename?: 'CommercialBannerRelationResponseCollection'; data: Array<{ __typename?: 'CommercialBannerEntity'; id?: string | null; attributes?: { __typename?: 'CommercialBanner'; name: string; link: string; openNewWindow?: boolean | null; desktopImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; mobileImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; pcase?: Array<{ __typename?: 'ComponentSharedPcase'; pcase: string } | null> | null } | null }> } | null } | null } | null } | null } | null; markenshops?: { __typename?: 'MarkenshopEntityResponseCollection'; data: Array<{ __typename?: 'MarkenshopEntity'; id?: string | null; attributes?: { __typename?: 'Markenshop'; sonataMarkenshopId?: any | null; title: string; link: string; image: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null } } | null }> } | null; themenshops?: { __typename?: 'ThemenshopEntityResponseCollection'; data: Array<{ __typename?: 'ThemenshopEntity'; id?: string | null; attributes?: { __typename?: 'Themenshop'; sonataThemenshopId?: any | null; title: string; excerpt?: string | null; image: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; button1?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null; button2?: { __typename?: 'ComponentSharedButton1'; label?: string | null; link?: string | null } | null } | null }> } | null; commercialBanners?: { __typename?: 'CommercialBannerEntityResponseCollection'; data: Array<{ __typename?: 'CommercialBannerEntity'; id?: string | null; attributes?: { __typename?: 'CommercialBanner'; name: string; link: string; openNewWindow?: boolean | null; desktopImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; mobileImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; pcase?: Array<{ __typename?: 'ComponentSharedPcase'; pcase: string } | null> | null } | null }> } | null; serviceBanners?: { __typename?: 'ServiceBannerEntityResponseCollection'; data: Array<{ __typename?: 'ServiceBannerEntity'; id?: string | null; attributes?: { __typename?: 'ServiceBanner'; name: string; link: string; openNewWindow?: boolean | null; desktopImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; mobileImage: { __typename?: 'UploadFileEntityResponse'; data?: { __typename?: 'UploadFileEntity'; attributes?: { __typename?: 'UploadFile'; url: string } | null } | null }; pcase?: Array<{ __typename?: 'ComponentSharedPcase'; pcase: string } | null> | null } | null }> } | null }

export type GetSettingsShowLogsQueryVariables = Exact<{ [key: string]: never }>

export type GetSettingsShowLogsQuery = { __typename?: 'Query'; setting?: { __typename?: 'SettingEntityResponse'; data?: { __typename?: 'SettingEntity'; attributes?: { __typename?: 'Setting'; showLogs?: boolean | null } | null } | null } | null }

export const GetApofinderConfig = gql`
    query getApofinderConfig($cnf: String) {
  apofinderConfigs(locale: "de", filters: {cnf: {eq: $cnf}}) {
    data {
      attributes {
        title
        subtitle
        cnf
        queryParameters {
          param
        }
        findPharmacyChoice {
          buttons {
            findPharmacyButtonLabel
            scanPharmacyButtonLabel
            displayScanButton
          }
          inputField {
            value
            placeholder
          }
          display
        }
        infoBlock {
          text
          image {
            data {
              attributes {
                url
              }
            }
          }
          imagePosition
          pzn
        }
        ads {
          ... on ComponentApofinderGoogleAd {
            headScript
            bodyScript
          }
          ... on ComponentApofinderImageAd {
            imageDesktop {
              data {
                attributes {
                  url
                }
              }
            }
            imageMobile {
              data {
                attributes {
                  url
                }
              }
            }
            link
            newWindow
          }
        }
      }
    }
  }
}
    `
export const GetApofinderLandingPage = gql`
    query getApofinderLandingPage {
  apofinderLandingPage(locale: "de") {
    data {
      attributes {
        title
        subtitle
        findPharmacyChoice {
          buttons {
            findPharmacyButtonLabel
            scanPharmacyButtonLabel
            displayScanButton
          }
          inputField {
            value
            placeholder
          }
          display
        }
        queryParameters {
          param
        }
        infoBlock {
          text
          image {
            data {
              attributes {
                url
              }
            }
          }
          imagePosition
          pzn
        }
        ads {
          ... on ComponentApofinderGoogleAd {
            id
            headScript
            bodyScript
          }
          ... on ComponentApofinderImageAd {
            id
            imageDesktop {
              data {
                attributes {
                  url
                }
              }
            }
            imageMobile {
              data {
                attributes {
                  url
                }
              }
            }
            link
            newWindow
          }
        }
      }
    }
  }
}
    `
export const GetEpaperApofinderConfig = gql`
    query getEpaperApofinderConfig {
  magazineHomepage(publicationState: LIVE) {
    data {
      attributes {
        apofinderConfig {
          options {
            couponCode
            headline
            text
            view
            openLinksInNewWindow
            hideMagazines
            pharmaciesPerPage
            query
            lat
            lng
            geolocation
            open
            delivery
            expressDelivery
            magazines
            pzn
            test
            pcase
            products
            productCategory
            wirkstoffe
            showAllPharmacies
            showAllPharmaciesFilter
            needsGoogleConsent
            consentActive
            activateAllPharmaciesFilter
            manufacturer
            destination
            customUrl
            recommendedProducts
            showRequestButton
          }
          filtersToHide {
            openPharmacies
            delivery
            expressDelivery
            magazines
          }
          utm {
            source
            medium
            campaign
            term
            content
          }
          settings {
            locationMarkerIcon
            pharmacyMarkerIcon
            primaryFont
            primaryFontFamily
            primaryColor
            secondaryColor
            pharmacyOpenColor
            pharmacyClosedColor
            searchButtonColor
            pharmacyButtonColor
            filterButtonsRadius
            pharmacyButtonRadius
          }
        }
      }
    }
  }
}
    `
export const GetMagazineHomepage = gql`
    query getMagazineHomepage {
  magazineHomepage(publicationState: LIVE) {
    data {
      attributes {
        sliderBannersCommercial {
          mobile {
            href
            image {
              data {
                attributes {
                  url
                  hash
                }
              }
            }
          }
          desktop {
            href
            image {
              data {
                attributes {
                  url
                  hash
                }
              }
            }
          }
        }
      }
    }
  }
}
    `
export const GetHeaderAndFooter = gql`
    query getHeaderAndFooter {
  footer(locale: "de") {
    data {
      attributes {
        paymentInfo {
          title
          image {
            data {
              attributes {
                url
              }
            }
          }
          description
          whenToDisplay
        }
        deliveryInfo {
          title
          deliveryItem {
            title
            description
            whenToDisplay
          }
        }
        infoLinks {
          title
          link {
            text
            url
            newTab
            elementId
          }
        }
        socialNetworks {
          title
          socialNetworkItem {
            network
            url
          }
        }
      }
    }
  }
  mainMenu(locale: "de") {
    data {
      attributes {
        logo {
          data {
            attributes {
              url
            }
          }
        }
        categories {
          title
          link {
            text
            url
            authDisplay
            newTab
            elementId
          }
        }
      }
    }
  }
}
    `
export const GetHomepage = gql`
    query getHomepage {
  homepage(locale: "de") {
    data {
      attributes {
        title
        image {
          data {
            attributes {
              url
            }
          }
        }
        themenshopSelection {
          title
          button {
            label
            link
          }
          displayAll
          customDisplay {
            data {
              id
              attributes {
                sonataThemenshopId
                image {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                title
                excerpt
                button1 {
                  label
                  link
                }
                button2 {
                  label
                  link
                }
              }
            }
          }
          useCustomDisplay
        }
        markenshopSelection {
          title
          button {
            label
            link
          }
          displayAll
          customDisplay {
            data {
              id
              attributes {
                sonataMarkenshopId
                image {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                title
                link
              }
            }
          }
          useCustomDisplay
        }
        serviceBannersSelection {
          displayAll
          customDisplay {
            data {
              id
              attributes {
                desktopImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                mobileImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                name
                link
                openNewWindow
                pcase {
                  pcase
                }
              }
            }
          }
          useCustomDisplay
        }
        commercialBannersSelection {
          displayAll
          useCustomDisplay
          customDisplay {
            data {
              id
              attributes {
                desktopImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                mobileImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                name
                link
                openNewWindow
                pcase {
                  pcase
                }
              }
            }
          }
        }
      }
    }
  }
  markenshops {
    data {
      id
      attributes {
        sonataMarkenshopId
        image {
          data {
            attributes {
              url
            }
          }
        }
        title
        link
      }
    }
  }
  themenshops {
    data {
      id
      attributes {
        sonataThemenshopId
        image {
          data {
            attributes {
              url
            }
          }
        }
        title
        excerpt
        button1 {
          label
          link
        }
        button2 {
          label
          link
        }
      }
    }
  }
  commercialBanners {
    data {
      id
      attributes {
        desktopImage {
          data {
            attributes {
              url
            }
          }
        }
        mobileImage {
          data {
            attributes {
              url
            }
          }
        }
        name
        link
        openNewWindow
        pcase {
          pcase
        }
      }
    }
  }
  serviceBanners {
    data {
      id
      attributes {
        desktopImage {
          data {
            attributes {
              url
            }
          }
        }
        mobileImage {
          data {
            attributes {
              url
            }
          }
        }
        name
        link
        openNewWindow
        pcase {
          pcase
        }
      }
    }
  }
}
    `
export const GetPharmacyStartpage = gql`
    query getPharmacyStartpage {
  pharmacyStartpage(locale: "de") {
    data {
      attributes {
        themenshopSelection {
          title
          button {
            label
            link
          }
          displayAll
          customDisplay {
            data {
              id
              attributes {
                sonataThemenshopId
                image {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                title
                excerpt
                button1 {
                  label
                  link
                }
                button2 {
                  label
                  link
                }
              }
            }
          }
          useCustomDisplay
        }
        markenshopSelection {
          title
          button {
            label
            link
          }
          displayAll
          customDisplay {
            data {
              id
              attributes {
                sonataMarkenshopId
                image {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                title
                link
              }
            }
          }
          useCustomDisplay
        }
        serviceBannersSelection {
          displayAll
          customDisplay {
            data {
              id
              attributes {
                desktopImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                mobileImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                name
                link
                openNewWindow
                pcase {
                  pcase
                }
              }
            }
          }
          useCustomDisplay
        }
        commercialBannersSelection {
          displayAll
          useCustomDisplay
          customDisplay {
            data {
              id
              attributes {
                desktopImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                mobileImage {
                  data {
                    attributes {
                      url
                    }
                  }
                }
                name
                link
                openNewWindow
                pcase {
                  pcase
                }
              }
            }
          }
        }
      }
    }
  }
  markenshops {
    data {
      id
      attributes {
        sonataMarkenshopId
        image {
          data {
            attributes {
              url
            }
          }
        }
        title
        link
      }
    }
  }
  themenshops {
    data {
      id
      attributes {
        sonataThemenshopId
        image {
          data {
            attributes {
              url
            }
          }
        }
        title
        excerpt
        button1 {
          label
          link
        }
        button2 {
          label
          link
        }
      }
    }
  }
  commercialBanners {
    data {
      id
      attributes {
        desktopImage {
          data {
            attributes {
              url
            }
          }
        }
        mobileImage {
          data {
            attributes {
              url
            }
          }
        }
        name
        link
        openNewWindow
        pcase {
          pcase
        }
      }
    }
  }
  serviceBanners {
    data {
      id
      attributes {
        desktopImage {
          data {
            attributes {
              url
            }
          }
        }
        mobileImage {
          data {
            attributes {
              url
            }
          }
        }
        name
        link
        openNewWindow
        pcase {
          pcase
        }
      }
    }
  }
}
    `
export const GetSettingsShowLogs = gql`
    query GetSettingsShowLogs {
  setting {
    data {
      attributes {
        showLogs
      }
    }
  }
}
    `
